import { AcceptEbomPartAllocationSuggestionCommand, AccountMutationRoot, AccountRoot, AddLibraryStepToModule, AddTreeGraphNode, AllocateArticleToStepCommand, AllocateEbomPartToStepCommand, Article, ArticleIssueLink, ArticleMutationRoot, ArticlePath, ArticleRoot, ArticleSearchQuery, Bop, BopIssueLink, BopUpload, BopUploadUsageLocation, BulkAllocateEbomPartsToStepCommand, CheckConfiguration, CheckI, CheckProposal, CheckSearchQuery, CheckUploadUsageLocation, ConfirmCheck, CreateArticle, CreateBopUpload, CreateCheckConfigurationCommand, CreateIcon, CreateImageStepUpload, CreateIssue, CreateIssueComment, CreateIssueLabel, CreateLibraryStep, CreateModule, CreateMultipartUpload, CreateOrganization, CreateProduct, CreateProductConfiguration, CreateProductionBatchCommand, CreateSite, CreateSnapshotStepUpload, CreateSnapshotUpload, CreateStep, CreateStepInput, CreateStepOutput, CreateStepProposalsFromDocx, CreateStepProposalsFromMedia, CreateStepProposalsFromPdf, CreateStepType, CreateTool, CreateUser, CreateVideoStepUpload, CsvConfig, CsvExtension, CurrentUserAndPermissions, DagNode, DeleteCheckCommand, DeleteOrganizationPermissions, DraftBopByDuplicating, DuplicateModule, DuplicateStep, Ebom, EbomPart, EbomPartAllocation, EbomPartAllocationSuggestion, EbomPartSearchQuery, FileUploadCheck, GenericExtension, IArticle, IArticleAllocation, IStepUpload, Icon, IconUploadUsageLocation, ImageExtension, ImageOptions, ImageStepUpload, InviteUserToOrganization, Issue, IssueComment, IssueCommentUploadUsageLocation, IssueLabel, IssueLinkI, IssueMutationRoot, IssueRoot, IssueSearchQuery, IssueUploadUsageLocation, IssuesPerDay, LibraryItemVersion, LinkIssueToArticle, LinkIssueToBop, LinkIssueToModule, LinkIssueToSerialNumber, LinkIssueToSerialNumbers, LinkIssueToStep, LoadEbomFromCsvCommand, LoadEbomFromStepFileCommand, LoadEbomResult, ManualArticleAllocation, ModelExtension, Module, ModuleIssueLink, ModuleNode, Move, Mutation, NumericCheck, OrgReachablePermission, Organization, OrganizationAiFeature, OrganizationUserPermissions, PdfExtension, PdfExtensionAnalysis, Product, ProductConfiguration, ProductConfigurationUploadUsageLocation, ProductMutationRoot, ProductRoot, ProductUploadUsageLocation, ProductionBatch, ProductionBatchPage, ProductionBatchQuery, PromoteStepToModule, Query, RemovedStep, ReplaceEbomPartAllocation, ReplaceEbomPartAllocationsCommand, SaveImageStepUploadEdit, SaveStepArticleTransforms, SaveStepViewport, SerialNumberIssueLink, SetConfirmCheckCommand, SetDagGraph, SetDagGraphNode, SetFileUploadCheckCommand, SetIssueLabels, SetIssueResolved, SetNumericCheckCommand, SetOrganizationAiFeature, SetOrganizationPermissions, SetPlacementTools, SetStepArticleVisibility, SetStepDuration, SetStepDurations, SetStepIcons, SetStepPreferred3dModel, SetStringCheckCommand, SetTreeGraph, SetTreeGraphNode, SetUserPermissions, ShopFloorMutationRoot, ShopFloorRoot, Site, SiteMutationRoot, SiteRoot, Step, StepArticleTransform, StepArticleTransformInput, StepDiff, StepImageUploadUsageLocation, StepInput, StepIssueLink, StepNode, StepOutput, StepProposal, StepProposalResult, StepType, StepUploadProposal, StepUploadUsageLocation, StepUsage, StepViewport, StringCheck, Tool, ToolImageUploadUsageLocation, TransferProductionBatchCommand, TreeGraph, TreeNode, UnlinkLibraryStep, UpdateArticle, UpdateCheckConfigurationCommand, UpdateIcon, UpdateImageStepUpload, UpdateIssue, UpdateIssueComment, UpdateIssueLabel, UpdateIssueLink, UpdateLibraryStepToLatestVersion, UpdateModule, UpdateOrganization, UpdateProduct, UpdateProductConfiguration, UpdateProductionBatchCommand, UpdateSite, UpdateStep, UpdateStepInput, UpdateStepOutput, UpdateStepType, UpdateTool, UpdateUpload, UpdateUser, UpdateVideoStepUpload, Upload, UploadMutationRoot, UploadQuery, UploadRoot, UploadUsageLocationI, User, UserSearchCriteria, VideoExtension, VideoStepUpload, AiFeature, ArticleType, ArticleUnit, CheckType, CsvEncoding, EbomPartAllocationSuggestionDecision, EbomPartAllocationSuggestionSource, EbomPartSnoozeStatus, EbomSourceType, GlbStatus, GraphEntityType, IssueSortBy, Language, PermissionOrganization, PermissionUser, Placement, SortDirection, StepArticleVisibility, StepChangeField, StepChangeKind, UploadSortDirection, UploadSortField, UploadUsageType, VersionStatus } from '@/generated/graphql';

export const mockAcceptEbomPartAllocationSuggestionCommand = (overrides?: Partial<AcceptEbomPartAllocationSuggestionCommand>): AcceptEbomPartAllocationSuggestionCommand => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'd7069a56-01b2-4974-858a-c24969d87f4d',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 8645,
    };
};

export const mockAccountMutationRoot = (overrides?: Partial<AccountMutationRoot>): AccountMutationRoot => {
    return {
        adminCreateOrganization: overrides && overrides.hasOwnProperty('adminCreateOrganization') ? overrides.adminCreateOrganization! : mockOrganization(),
        adminCreateUser: overrides && overrides.hasOwnProperty('adminCreateUser') ? overrides.adminCreateUser! : mockUser(),
        adminDeleteOrganization: overrides && overrides.hasOwnProperty('adminDeleteOrganization') ? overrides.adminDeleteOrganization! : 'a07ddf1d-a6fc-497b-8329-ed822aaef506',
        adminDeleteOrganizationPermissions: overrides && overrides.hasOwnProperty('adminDeleteOrganizationPermissions') ? overrides.adminDeleteOrganizationPermissions! : false,
        adminSetOrganizationPermissions: overrides && overrides.hasOwnProperty('adminSetOrganizationPermissions') ? overrides.adminSetOrganizationPermissions! : [PermissionOrganization.OrgAdmin],
        adminSetUserPermissions: overrides && overrides.hasOwnProperty('adminSetUserPermissions') ? overrides.adminSetUserPermissions! : [PermissionUser.UserGlobalAdmin],
        adminUpdateOrganization: overrides && overrides.hasOwnProperty('adminUpdateOrganization') ? overrides.adminUpdateOrganization! : mockOrganization(),
        adminUpdateUser: overrides && overrides.hasOwnProperty('adminUpdateUser') ? overrides.adminUpdateUser! : mockUser(),
        agreeToTerms: overrides && overrides.hasOwnProperty('agreeToTerms') ? overrides.agreeToTerms! : false,
        deleteOrganizationPermissions: overrides && overrides.hasOwnProperty('deleteOrganizationPermissions') ? overrides.deleteOrganizationPermissions! : true,
        inviteUserToOrganization: overrides && overrides.hasOwnProperty('inviteUserToOrganization') ? overrides.inviteUserToOrganization! : true,
        setOrganizationAiFeature: overrides && overrides.hasOwnProperty('setOrganizationAiFeature') ? overrides.setOrganizationAiFeature! : mockOrganization(),
        setOrganizationPermissions: overrides && overrides.hasOwnProperty('setOrganizationPermissions') ? overrides.setOrganizationPermissions! : [PermissionOrganization.OrgAdmin],
        updateOrganization: overrides && overrides.hasOwnProperty('updateOrganization') ? overrides.updateOrganization! : mockOrganization(),
    };
};

export const mockAccountRoot = (overrides?: Partial<AccountRoot>): AccountRoot => {
    return {
        adminOrganizationPermissions: overrides && overrides.hasOwnProperty('adminOrganizationPermissions') ? overrides.adminOrganizationPermissions! : [mockOrganizationUserPermissions()],
        adminOrganizations: overrides && overrides.hasOwnProperty('adminOrganizations') ? overrides.adminOrganizations! : [mockOrganization()],
        adminSearchUsers: overrides && overrides.hasOwnProperty('adminSearchUsers') ? overrides.adminSearchUsers! : [mockUser()],
        adminUser: overrides && overrides.hasOwnProperty('adminUser') ? overrides.adminUser! : mockUser(),
        adminUserPermissions: overrides && overrides.hasOwnProperty('adminUserPermissions') ? overrides.adminUserPermissions! : [PermissionUser.UserGlobalAdmin],
        currentOrganization: overrides && overrides.hasOwnProperty('currentOrganization') ? overrides.currentOrganization! : mockOrganization(),
        hasAgreedToTerms: overrides && overrides.hasOwnProperty('hasAgreedToTerms') ? overrides.hasAgreedToTerms! : false,
        isEmailTaken: overrides && overrides.hasOwnProperty('isEmailTaken') ? overrides.isEmailTaken! : false,
        isOrganizationSlugTaken: overrides && overrides.hasOwnProperty('isOrganizationSlugTaken') ? overrides.isOrganizationSlugTaken! : false,
        me: overrides && overrides.hasOwnProperty('me') ? overrides.me! : mockCurrentUserAndPermissions(),
        orgPermissionsHierarchy: overrides && overrides.hasOwnProperty('orgPermissionsHierarchy') ? overrides.orgPermissionsHierarchy! : [mockOrgReachablePermission()],
        organizationBySlug: overrides && overrides.hasOwnProperty('organizationBySlug') ? overrides.organizationBySlug! : mockOrganization(),
        organizationPermissions: overrides && overrides.hasOwnProperty('organizationPermissions') ? overrides.organizationPermissions! : [PermissionOrganization.OrgAdmin],
        organizationSearchUsers: overrides && overrides.hasOwnProperty('organizationSearchUsers') ? overrides.organizationSearchUsers! : [mockUser()],
        organizationUser: overrides && overrides.hasOwnProperty('organizationUser') ? overrides.organizationUser! : mockUser(),
        organizationUsers: overrides && overrides.hasOwnProperty('organizationUsers') ? overrides.organizationUsers! : [mockUser()],
        organizations: overrides && overrides.hasOwnProperty('organizations') ? overrides.organizations! : [mockOrganizationUserPermissions()],
    };
};

export const mockAddLibraryStepToModule = (overrides?: Partial<AddLibraryStepToModule>): AddLibraryStepToModule => {
    return {
        libraryStepId: overrides && overrides.hasOwnProperty('libraryStepId') ? overrides.libraryStepId! : '80d13e65-a78c-4836-b887-81cd9811b50a',
        moduleId: overrides && overrides.hasOwnProperty('moduleId') ? overrides.moduleId! : 'bb95d5f7-1d53-44ef-a26f-d235c46fbaa8',
        nodeId: overrides && overrides.hasOwnProperty('nodeId') ? overrides.nodeId! : 'e5b77433-ac77-4513-8f25-4370ceb15458',
    };
};

export const mockAddTreeGraphNode = (overrides?: Partial<AddTreeGraphNode>): AddTreeGraphNode => {
    return {
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'feeb19ae-201a-4589-b5cb-482a8348f4d7',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : mockSetTreeGraphNode(),
    };
};

export const mockAllocateArticleToStepCommand = (overrides?: Partial<AllocateArticleToStepCommand>): AllocateArticleToStepCommand => {
    return {
        articleId: overrides && overrides.hasOwnProperty('articleId') ? overrides.articleId! : '965b7044-4b12-4244-b7d0-e3f21f59553e',
        graphNodeStepId: overrides && overrides.hasOwnProperty('graphNodeStepId') ? overrides.graphNodeStepId! : '7e0672fb-8a60-4884-ba01-6168a5e06c0e',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 3838,
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'f9a1694c-03ca-43c4-8987-5a6c4914c927',
    };
};

export const mockAllocateEbomPartToStepCommand = (overrides?: Partial<AllocateEbomPartToStepCommand>): AllocateEbomPartToStepCommand => {
    return {
        ebomPartId: overrides && overrides.hasOwnProperty('ebomPartId') ? overrides.ebomPartId! : '15a1122c-e630-47b5-88a8-c46940ac4c3d',
        graphNodeStepId: overrides && overrides.hasOwnProperty('graphNodeStepId') ? overrides.graphNodeStepId! : '00cef52b-06d1-4832-9b40-07a9a2adfce8',
        instanceIndexes: overrides && overrides.hasOwnProperty('instanceIndexes') ? overrides.instanceIndexes! : [2986],
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 6481,
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'c4a9243c-0c72-4b63-8547-9ef4f1fece62',
    };
};

export const mockArticle = (overrides?: Partial<Article>): Article => {
    return {
        articleNumber: overrides && overrides.hasOwnProperty('articleNumber') ? overrides.articleNumber! : 'villa',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b349255d-fd73-4f00-b59d-c1494a5a641b',
        issueLinks: overrides && overrides.hasOwnProperty('issueLinks') ? overrides.issueLinks! : [mockArticleIssueLink()],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'candidus',
        released: overrides && overrides.hasOwnProperty('released') ? overrides.released! : false,
        revision: overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'adaugeo',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ArticleType.Consumable,
        unit: overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : ArticleUnit.Gram,
    };
};

export const mockArticleIssueLink = (overrides?: Partial<ArticleIssueLink>): ArticleIssueLink => {
    return {
        article: overrides && overrides.hasOwnProperty('article') ? overrides.article! : mockArticle(),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'hic',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '32bf09a1-4ba1-456f-bc99-4d8d23142cab',
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssue(),
    };
};

export const mockArticleMutationRoot = (overrides?: Partial<ArticleMutationRoot>): ArticleMutationRoot => {
    return {
        acceptEbomPartAllocationSuggestion: overrides && overrides.hasOwnProperty('acceptEbomPartAllocationSuggestion') ? overrides.acceptEbomPartAllocationSuggestion! : mockEbomPartAllocationSuggestion(),
        acceptEbomPartAllocationSuggestions: overrides && overrides.hasOwnProperty('acceptEbomPartAllocationSuggestions') ? overrides.acceptEbomPartAllocationSuggestions! : ['d4cc8317-b871-43c0-9fe4-33deaa0d7e5c'],
        allocateArticleToStep: overrides && overrides.hasOwnProperty('allocateArticleToStep') ? overrides.allocateArticleToStep! : true,
        allocateEbomPartToStep: overrides && overrides.hasOwnProperty('allocateEbomPartToStep') ? overrides.allocateEbomPartToStep! : false,
        bulkAllocateEbomPartsToStep: overrides && overrides.hasOwnProperty('bulkAllocateEbomPartsToStep') ? overrides.bulkAllocateEbomPartsToStep! : false,
        createArticle: overrides && overrides.hasOwnProperty('createArticle') ? overrides.createArticle! : mockArticle(),
        createEbomPartAllocationSuggestions: overrides && overrides.hasOwnProperty('createEbomPartAllocationSuggestions') ? overrides.createEbomPartAllocationSuggestions! : [mockEbomPartAllocationSuggestion()],
        deleteArticle: overrides && overrides.hasOwnProperty('deleteArticle') ? overrides.deleteArticle! : '747bcb37-0331-4cc0-8a0c-df96006c9509',
        deleteEbom: overrides && overrides.hasOwnProperty('deleteEbom') ? overrides.deleteEbom! : '8a328b70-22ea-425a-b7c6-bad083a8d94b',
        loadEbomFromCsv: overrides && overrides.hasOwnProperty('loadEbomFromCsv') ? overrides.loadEbomFromCsv! : mockLoadEbomResult(),
        loadEbomFromStepFile: overrides && overrides.hasOwnProperty('loadEbomFromStepFile') ? overrides.loadEbomFromStepFile! : mockLoadEbomResult(),
        promoteEbomPartsToArticles: overrides && overrides.hasOwnProperty('promoteEbomPartsToArticles') ? overrides.promoteEbomPartsToArticles! : [mockEbomPart()],
        rejectEbomPartAllocationSuggestion: overrides && overrides.hasOwnProperty('rejectEbomPartAllocationSuggestion') ? overrides.rejectEbomPartAllocationSuggestion! : mockEbomPartAllocationSuggestion(),
        rejectEbomPartAllocationSuggestions: overrides && overrides.hasOwnProperty('rejectEbomPartAllocationSuggestions') ? overrides.rejectEbomPartAllocationSuggestions! : ['59f56ddd-f0d3-4e75-b6d7-99d327c2b8fb'],
        replaceEbomPartAllocations: overrides && overrides.hasOwnProperty('replaceEbomPartAllocations') ? overrides.replaceEbomPartAllocations! : false,
        snoozeEbomParts: overrides && overrides.hasOwnProperty('snoozeEbomParts') ? overrides.snoozeEbomParts! : false,
        unsnoozeEbomParts: overrides && overrides.hasOwnProperty('unsnoozeEbomParts') ? overrides.unsnoozeEbomParts! : false,
        updateArticle: overrides && overrides.hasOwnProperty('updateArticle') ? overrides.updateArticle! : mockArticle(),
    };
};

export const mockArticlePath = (overrides?: Partial<ArticlePath>): ArticlePath => {
    return {
        articleNumbers: overrides && overrides.hasOwnProperty('articleNumbers') ? overrides.articleNumbers! : ['admoneo'],
    };
};

export const mockArticleRoot = (overrides?: Partial<ArticleRoot>): ArticleRoot => {
    return {
        article: overrides && overrides.hasOwnProperty('article') ? overrides.article! : mockArticle(),
        articles: overrides && overrides.hasOwnProperty('articles') ? overrides.articles! : [mockArticle()],
        ebom: overrides && overrides.hasOwnProperty('ebom') ? overrides.ebom! : mockEbom(),
        ebomPart: overrides && overrides.hasOwnProperty('ebomPart') ? overrides.ebomPart! : mockEbomPart(),
        ebomParts: overrides && overrides.hasOwnProperty('ebomParts') ? overrides.ebomParts! : [mockEbomPart()],
        ebomsForBop: overrides && overrides.hasOwnProperty('ebomsForBop') ? overrides.ebomsForBop! : [mockEbom()],
    };
};

export const mockArticleSearchQuery = (overrides?: Partial<ArticleSearchQuery>): ArticleSearchQuery => {
    return {
        articleNumber: overrides && overrides.hasOwnProperty('articleNumber') ? overrides.articleNumber! : 'socius',
        containsString: overrides && overrides.hasOwnProperty('containsString') ? overrides.containsString! : 'commodi',
        revision: overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'tenus',
    };
};

export const mockBop = (overrides?: Partial<Bop>): Bop => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e5e78c64-fde2-45c0-82db-eabe3156105a',
        issueLinks: overrides && overrides.hasOwnProperty('issueLinks') ? overrides.issueLinks! : [mockArticleIssueLink()],
        nodes: overrides && overrides.hasOwnProperty('nodes') ? overrides.nodes! : [mockModuleNode()],
        productConfiguration: overrides && overrides.hasOwnProperty('productConfiguration') ? overrides.productConfiguration! : mockProductConfiguration(),
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : mockSite(),
        uploads: overrides && overrides.hasOwnProperty('uploads') ? overrides.uploads! : [mockBopUpload()],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 7510,
        versionStatus: overrides && overrides.hasOwnProperty('versionStatus') ? overrides.versionStatus! : VersionStatus.Approved,
    };
};

export const mockBopIssueLink = (overrides?: Partial<BopIssueLink>): BopIssueLink => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'corrupti',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6c5f1d2d-5553-43ac-af3c-89f23d52a5ef',
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssue(),
    };
};

export const mockBopUpload = (overrides?: Partial<BopUpload>): BopUpload => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        glbStatus: overrides && overrides.hasOwnProperty('glbStatus') ? overrides.glbStatus! : GlbStatus.Converting,
        glbUpload: overrides && overrides.hasOwnProperty('glbUpload') ? overrides.glbUpload! : mockUpload(),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '2e15c6b2-8e45-46f6-90f8-3494a9406576',
        inUse: overrides && overrides.hasOwnProperty('inUse') ? overrides.inUse! : false,
        upload: overrides && overrides.hasOwnProperty('upload') ? overrides.upload! : mockUpload(),
    };
};

export const mockBopUploadUsageLocation = (overrides?: Partial<BopUploadUsageLocation>): BopUploadUsageLocation => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockBulkAllocateEbomPartsToStepCommand = (overrides?: Partial<BulkAllocateEbomPartsToStepCommand>): BulkAllocateEbomPartsToStepCommand => {
    return {
        ebomPartIds: overrides && overrides.hasOwnProperty('ebomPartIds') ? overrides.ebomPartIds! : ['5fbb8e1e-f99d-4d1b-a8f5-e72469b37608'],
        graphNodeStepId: overrides && overrides.hasOwnProperty('graphNodeStepId') ? overrides.graphNodeStepId! : '54fd1c4c-490e-456b-a1fe-0704020774e7',
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '731a2c81-7c7b-420f-b6a0-9a75ba6ff0d8',
    };
};

export const mockCheckConfiguration = (overrides?: Partial<CheckConfiguration>): CheckConfiguration => {
    return {
        allowedMimeTypes: overrides && overrides.hasOwnProperty('allowedMimeTypes') ? overrides.allowedMimeTypes! : ['defetiscor'],
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'testimonium',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f2ac1e3c-983a-45ab-af52-7771f140bdb2',
        isRequired: overrides && overrides.hasOwnProperty('isRequired') ? overrides.isRequired! : true,
        lowerLimit: overrides && overrides.hasOwnProperty('lowerLimit') ? overrides.lowerLimit! : 8806,
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : 7587,
        pinnedId: overrides && overrides.hasOwnProperty('pinnedId') ? overrides.pinnedId! : 'bad361c4-2f85-4b7c-bff2-3c30c9ef0a39',
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : CheckType.Confirmation,
        unit: overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : 'confido',
        unreleasedChecks: overrides && overrides.hasOwnProperty('unreleasedChecks') ? overrides.unreleasedChecks! : [mockConfirmCheck()],
        upperLimit: overrides && overrides.hasOwnProperty('upperLimit') ? overrides.upperLimit! : 2068,
    };
};

export const mockCheckI = (overrides?: Partial<CheckI>): CheckI => {
    return {
        configuration: overrides && overrides.hasOwnProperty('configuration') ? overrides.configuration! : mockCheckConfiguration(),
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'cuppedia',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '112de1d5-e6bf-4bc0-8000-1ca40fbb1e12',
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'stultus',
        released: overrides && overrides.hasOwnProperty('released') ? overrides.released! : false,
        reportingUser: overrides && overrides.hasOwnProperty('reportingUser') ? overrides.reportingUser! : mockUser(),
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'volup',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'cras',
    };
};

export const mockCheckProposal = (overrides?: Partial<CheckProposal>): CheckProposal => {
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'carpo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3bd57423-7db0-4be2-80b2-56ae029aeb5d',
        isRequired: overrides && overrides.hasOwnProperty('isRequired') ? overrides.isRequired! : true,
        lowerLimit: overrides && overrides.hasOwnProperty('lowerLimit') ? overrides.lowerLimit! : 6749,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : CheckType.Confirmation,
        upperLimit: overrides && overrides.hasOwnProperty('upperLimit') ? overrides.upperLimit! : 3470,
    };
};

export const mockCheckSearchQuery = (overrides?: Partial<CheckSearchQuery>): CheckSearchQuery => {
    return {
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'comprehendo',
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'doloremque',
    };
};

export const mockCheckUploadUsageLocation = (overrides?: Partial<CheckUploadUsageLocation>): CheckUploadUsageLocation => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockConfirmCheck = (overrides?: Partial<ConfirmCheck>): ConfirmCheck => {
    return {
        configuration: overrides && overrides.hasOwnProperty('configuration') ? overrides.configuration! : mockCheckConfiguration(),
        confirmed: overrides && overrides.hasOwnProperty('confirmed') ? overrides.confirmed! : true,
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'sperno',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '20cda390-d567-4355-b7da-a94f42bb4c0d',
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'tenetur',
        released: overrides && overrides.hasOwnProperty('released') ? overrides.released! : false,
        reportingUser: overrides && overrides.hasOwnProperty('reportingUser') ? overrides.reportingUser! : mockUser(),
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'inventore',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'reiciendis',
    };
};

export const mockCreateArticle = (overrides?: Partial<CreateArticle>): CreateArticle => {
    return {
        articleNumber: overrides && overrides.hasOwnProperty('articleNumber') ? overrides.articleNumber! : 'aggero',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bfe10ff1-a42c-4141-88dc-bf73b9bb87fe',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'fugit',
        revision: overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'dolorem',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ArticleType.Consumable,
        unit: overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : ArticleUnit.Gram,
    };
};

export const mockCreateBopUpload = (overrides?: Partial<CreateBopUpload>): CreateBopUpload => {
    return {
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : 'b51e1947-db05-4052-8a40-b640ed7f0f1d',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'db2a2cd9-c569-4c81-a812-43ae50bd3523',
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : 'a635badb-d4ba-481b-aeac-4eb524e6c6df',
    };
};

export const mockCreateCheckConfigurationCommand = (overrides?: Partial<CreateCheckConfigurationCommand>): CreateCheckConfigurationCommand => {
    return {
        allowedMimeTypes: overrides && overrides.hasOwnProperty('allowedMimeTypes') ? overrides.allowedMimeTypes! : ['ultra'],
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : '9d561cf4-ab3f-4e21-8d7b-b08f2d12929f',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tollo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '88997073-c854-4489-b9f5-afde6413b224',
        isRequired: overrides && overrides.hasOwnProperty('isRequired') ? overrides.isRequired! : true,
        lowerLimit: overrides && overrides.hasOwnProperty('lowerLimit') ? overrides.lowerLimit! : 4681,
        moduleId: overrides && overrides.hasOwnProperty('moduleId') ? overrides.moduleId! : 'fee698e6-1cdb-4c67-a3bd-54932dea99cf',
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : 3282,
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '72acd933-ee2b-4b20-bff9-529400f7d731',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : CheckType.Confirmation,
        unit: overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : 'beatus',
        upperLimit: overrides && overrides.hasOwnProperty('upperLimit') ? overrides.upperLimit! : 1040,
    };
};

export const mockCreateIcon = (overrides?: Partial<CreateIcon>): CreateIcon => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'fd8d210a-218d-4392-b76f-2c37d5bb8d33',
        imageUploadId: overrides && overrides.hasOwnProperty('imageUploadId') ? overrides.imageUploadId! : '58d9cc8d-7565-4328-bfce-6688959bae60',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ascit',
    };
};

export const mockCreateImageStepUpload = (overrides?: Partial<CreateImageStepUpload>): CreateImageStepUpload => {
    return {
        caption: overrides && overrides.hasOwnProperty('caption') ? overrides.caption! : 'tergiversatio',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9d4edbd0-939c-4efc-8b77-e77abfd35986',
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '02181051-5698-4b41-ade6-a7d9f7648afb',
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : '74181c35-d972-4c46-a582-2ec246be93cf',
    };
};

export const mockCreateIssue = (overrides?: Partial<CreateIssue>): CreateIssue => {
    return {
        assignedToUserIds: overrides && overrides.hasOwnProperty('assignedToUserIds') ? overrides.assignedToUserIds! : ['6b8a9a33-e18c-4c12-98bf-d53659f86622'],
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'velut',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3a9b028e-ec69-46b7-8399-8fb3a5bae06a',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quo',
        uploadIds: overrides && overrides.hasOwnProperty('uploadIds') ? overrides.uploadIds! : ['60dbd3d7-c38c-4f95-8e97-cab96404553c'],
    };
};

export const mockCreateIssueComment = (overrides?: Partial<CreateIssueComment>): CreateIssueComment => {
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'bibo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6747d8b4-b870-49e1-83d7-b3a72e39901d',
        issueId: overrides && overrides.hasOwnProperty('issueId') ? overrides.issueId! : 'ba644af1-749a-4d5c-806f-6845a204838f',
        uploadIds: overrides && overrides.hasOwnProperty('uploadIds') ? overrides.uploadIds! : ['15b9c0ac-94aa-4a96-a044-04f5ba8720f9'],
    };
};

export const mockCreateIssueLabel = (overrides?: Partial<CreateIssueLabel>): CreateIssueLabel => {
    return {
        color: overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'alo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ventito',
    };
};

export const mockCreateLibraryStep = (overrides?: Partial<CreateLibraryStep>): CreateLibraryStep => {
    return {
        durationInSeconds: overrides && overrides.hasOwnProperty('durationInSeconds') ? overrides.durationInSeconds! : 2945,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cf8e6c07-d30e-464a-b6d5-20fe1b9f16d2',
        instructionText: overrides && overrides.hasOwnProperty('instructionText') ? overrides.instructionText! : 'tyrannus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ascit',
        stepTypeId: overrides && overrides.hasOwnProperty('stepTypeId') ? overrides.stepTypeId! : '219ab9c0-e78a-41b1-ac30-7445c0a66a63',
        toolIds: overrides && overrides.hasOwnProperty('toolIds') ? overrides.toolIds! : ['4a5f1d80-238d-4fa5-9c13-ffd9a17b6d08'],
        warningText: overrides && overrides.hasOwnProperty('warningText') ? overrides.warningText! : 'color',
    };
};

export const mockCreateModule = (overrides?: Partial<CreateModule>): CreateModule => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'deleo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tenax',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '389b10df-98f1-4e02-beb2-dc6e85c8c3d1',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'curso',
        productId: overrides && overrides.hasOwnProperty('productId') ? overrides.productId! : 'bdc1f047-a9be-4546-baf9-3ed2213248a3',
    };
};

export const mockCreateMultipartUpload = (overrides?: Partial<CreateMultipartUpload>): CreateMultipartUpload => {
    return {
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : 'tot',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a5c796df-536d-4e43-9fc7-9d75b8f4a601',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'delego',
    };
};

export const mockCreateOrganization = (overrides?: Partial<CreateOrganization>): CreateOrganization => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7eebcdb1-edad-45f1-ad68-fcc18a8ff474',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'laborum',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'advoco',
    };
};

export const mockCreateProduct = (overrides?: Partial<CreateProduct>): CreateProduct => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'textus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'verto',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '159f2054-3c2a-46d1-baf3-01852e038a8b',
        imageUploadId: overrides && overrides.hasOwnProperty('imageUploadId') ? overrides.imageUploadId! : 'ba7a6d8d-f175-4b34-9f20-85a751a1e733',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vulnus',
    };
};

export const mockCreateProductConfiguration = (overrides?: Partial<CreateProductConfiguration>): CreateProductConfiguration => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'ad',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'deinde',
        forProductId: overrides && overrides.hasOwnProperty('forProductId') ? overrides.forProductId! : '1fca4434-1e37-4c0e-839f-9eec612ad36b',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bc142b11-5dce-41cf-b539-346743f70208',
        imageUploadId: overrides && overrides.hasOwnProperty('imageUploadId') ? overrides.imageUploadId! : 'd60b4475-9d0f-4818-ae8e-18220baa9d38',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vilitas',
    };
};

export const mockCreateProductionBatchCommand = (overrides?: Partial<CreateProductionBatchCommand>): CreateProductionBatchCommand => {
    return {
        assignedUserId: overrides && overrides.hasOwnProperty('assignedUserId') ? overrides.assignedUserId! : 'e3d52680-ed20-4d25-ae58-0d7e8d7c7cfb',
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : 'f1c395fd-d354-415d-8c9c-b4860462dfef',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '77f1b105-8383-47b9-ac22-f7470d684e49',
        moduleId: overrides && overrides.hasOwnProperty('moduleId') ? overrides.moduleId! : 'd0142b74-9a0e-4a8d-91ac-b1bb78bdab2f',
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'vulnero',
        serialNumbers: overrides && overrides.hasOwnProperty('serialNumbers') ? overrides.serialNumbers! : ['b0512cb6-cb4b-48bc-996b-a0b5ccec4d18'],
    };
};

export const mockCreateSite = (overrides?: Partial<CreateSite>): CreateSite => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'corrupti',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f7d69a9e-1516-4f0f-a11a-e7fe9a82b5b6',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'combibo',
    };
};

export const mockCreateSnapshotStepUpload = (overrides?: Partial<CreateSnapshotStepUpload>): CreateSnapshotStepUpload => {
    return {
        attachmentId: overrides && overrides.hasOwnProperty('attachmentId') ? overrides.attachmentId! : 'b9006298-21c7-4ccf-b68a-52462056f7e6',
        caption: overrides && overrides.hasOwnProperty('caption') ? overrides.caption! : 'aestas',
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'aeb7497c-94ff-4ef9-b65f-ed57b23c9754',
        timestampInMillis: overrides && overrides.hasOwnProperty('timestampInMillis') ? overrides.timestampInMillis! : 5108,
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : 'f2319eda-5c28-4499-ba59-7206716171c7',
    };
};

export const mockCreateSnapshotUpload = (overrides?: Partial<CreateSnapshotUpload>): CreateSnapshotUpload => {
    return {
        timestampInMillis: overrides && overrides.hasOwnProperty('timestampInMillis') ? overrides.timestampInMillis! : 3237,
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : 'fffb9b60-eeab-4a8b-b944-31f194670a25',
    };
};

export const mockCreateStep = (overrides?: Partial<CreateStep>): CreateStep => {
    return {
        durationInSeconds: overrides && overrides.hasOwnProperty('durationInSeconds') ? overrides.durationInSeconds! : 1017,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0a965778-1f88-4dff-8fe0-7e8b3c2c9eef',
        instructionText: overrides && overrides.hasOwnProperty('instructionText') ? overrides.instructionText! : 'crux',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cetera',
        productId: overrides && overrides.hasOwnProperty('productId') ? overrides.productId! : '8ea93a80-ddf5-40b9-937f-26a6774fabab',
        stepTypeId: overrides && overrides.hasOwnProperty('stepTypeId') ? overrides.stepTypeId! : '54c505c9-c4ce-44b4-a03b-8d2258b3d627',
        toolIds: overrides && overrides.hasOwnProperty('toolIds') ? overrides.toolIds! : ['3f4d095b-9b3b-48b0-bb19-b4895cda4e1b'],
        warningText: overrides && overrides.hasOwnProperty('warningText') ? overrides.warningText! : 'contego',
    };
};

export const mockCreateStepInput = (overrides?: Partial<CreateStepInput>): CreateStepInput => {
    return {
        graphNodeStepId: overrides && overrides.hasOwnProperty('graphNodeStepId') ? overrides.graphNodeStepId! : 'b26e02bd-c29d-43d6-ae41-75f0d26ad9be',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8033491a-d72b-400f-ac2d-af5d85ce8364',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 2955,
        moduleId: overrides && overrides.hasOwnProperty('moduleId') ? overrides.moduleId! : 'c869d997-21a5-4b8c-9c13-6f85aa6921ea',
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'c7cf6c73-1726-4e3b-8c06-cfb2d37cd519',
        stepOutputId: overrides && overrides.hasOwnProperty('stepOutputId') ? overrides.stepOutputId! : '06f6cd7c-ae17-4cb6-b1b9-064fbb971643',
    };
};

export const mockCreateStepOutput = (overrides?: Partial<CreateStepOutput>): CreateStepOutput => {
    return {
        articleId: overrides && overrides.hasOwnProperty('articleId') ? overrides.articleId! : '683d6266-8466-461c-b182-3fe55874a315',
        graphNodeStepId: overrides && overrides.hasOwnProperty('graphNodeStepId') ? overrides.graphNodeStepId! : 'be4a033d-160a-47ea-b9e8-c5bb4267b608',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9331c01e-dc5b-491f-9945-d32adcb30708',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 2364,
        moduleId: overrides && overrides.hasOwnProperty('moduleId') ? overrides.moduleId! : 'beb9fe02-589f-4af8-84e9-b1d212de8d31',
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '49512516-3826-459e-88c9-8407705d1ba9',
    };
};

export const mockCreateStepProposalsFromDocx = (overrides?: Partial<CreateStepProposalsFromDocx>): CreateStepProposalsFromDocx => {
    return {
        additionalPrompt: overrides && overrides.hasOwnProperty('additionalPrompt') ? overrides.additionalPrompt! : 'patria',
        fromUploadId: overrides && overrides.hasOwnProperty('fromUploadId') ? overrides.fromUploadId! : '987f768b-e562-4afb-bc4e-9bae699c2870',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bb85b631-1dde-40c2-8180-d7a980bd5261',
        language: overrides && overrides.hasOwnProperty('language') ? overrides.language! : Language.En,
        outLanguage: overrides && overrides.hasOwnProperty('outLanguage') ? overrides.outLanguage! : Language.En,
    };
};

export const mockCreateStepProposalsFromMedia = (overrides?: Partial<CreateStepProposalsFromMedia>): CreateStepProposalsFromMedia => {
    return {
        additionalPrompt: overrides && overrides.hasOwnProperty('additionalPrompt') ? overrides.additionalPrompt! : 'adhuc',
        averageStepSizeInSeconds: overrides && overrides.hasOwnProperty('averageStepSizeInSeconds') ? overrides.averageStepSizeInSeconds! : 6835,
        fromUploadId: overrides && overrides.hasOwnProperty('fromUploadId') ? overrides.fromUploadId! : '38d73c02-40e2-4f02-9c0d-52408438c84f',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'db92d16e-485d-4550-bf5d-f74f9116b2a7',
        inLanguage: overrides && overrides.hasOwnProperty('inLanguage') ? overrides.inLanguage! : Language.En,
        outLanguage: overrides && overrides.hasOwnProperty('outLanguage') ? overrides.outLanguage! : Language.En,
    };
};

export const mockCreateStepProposalsFromPdf = (overrides?: Partial<CreateStepProposalsFromPdf>): CreateStepProposalsFromPdf => {
    return {
        additionalPrompt: overrides && overrides.hasOwnProperty('additionalPrompt') ? overrides.additionalPrompt! : 'tandem',
        firstPage: overrides && overrides.hasOwnProperty('firstPage') ? overrides.firstPage! : 918,
        fromUploadId: overrides && overrides.hasOwnProperty('fromUploadId') ? overrides.fromUploadId! : '0a002b45-b9fc-4b25-9d7c-906179b15cad',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bece90f5-d393-43ce-986c-a32030d354b1',
        language: overrides && overrides.hasOwnProperty('language') ? overrides.language! : Language.En,
        lastPage: overrides && overrides.hasOwnProperty('lastPage') ? overrides.lastPage! : 2631,
        outLanguage: overrides && overrides.hasOwnProperty('outLanguage') ? overrides.outLanguage! : Language.En,
    };
};

export const mockCreateStepType = (overrides?: Partial<CreateStepType>): CreateStepType => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '35055d18-7540-4fad-a2d1-653d4160214e',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'talio',
    };
};

export const mockCreateTool = (overrides?: Partial<CreateTool>): CreateTool => {
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'unde',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ac4636cd-666d-4a9e-ba67-27f9324c81c3',
        imageUploadIds: overrides && overrides.hasOwnProperty('imageUploadIds') ? overrides.imageUploadIds! : ['199468ae-feae-4e46-8956-cf2002feeae1'],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vitiosus',
        siteId: overrides && overrides.hasOwnProperty('siteId') ? overrides.siteId! : '428c2f85-2a34-4bc1-ac5a-fcc204d26ac4',
    };
};

export const mockCreateUser = (overrides?: Partial<CreateUser>): CreateUser => {
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'sto',
        firstname: overrides && overrides.hasOwnProperty('firstname') ? overrides.firstname! : 'admiratio',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bf124ac1-96c3-4727-af8a-26778c79b5f0',
        lastname: overrides && overrides.hasOwnProperty('lastname') ? overrides.lastname! : 'cotidie',
        needsPassword: overrides && overrides.hasOwnProperty('needsPassword') ? overrides.needsPassword! : false,
    };
};

export const mockCreateVideoStepUpload = (overrides?: Partial<CreateVideoStepUpload>): CreateVideoStepUpload => {
    return {
        caption: overrides && overrides.hasOwnProperty('caption') ? overrides.caption! : 'caritas',
        fragmentEndInMillis: overrides && overrides.hasOwnProperty('fragmentEndInMillis') ? overrides.fragmentEndInMillis! : 7017,
        fragmentLoop: overrides && overrides.hasOwnProperty('fragmentLoop') ? overrides.fragmentLoop! : true,
        fragmentStartInMillis: overrides && overrides.hasOwnProperty('fragmentStartInMillis') ? overrides.fragmentStartInMillis! : 5272,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cf0b3c4a-1062-460a-bc4a-664581db3e15',
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '85418dfd-f330-48be-a42c-ba7e049e3e43',
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : '6ce9e24d-7ad1-4691-8d4f-e226d4fdefd2',
    };
};

export const mockCsvConfig = (overrides?: Partial<CsvConfig>): CsvConfig => {
    return {
        articleNumberColumn: overrides && overrides.hasOwnProperty('articleNumberColumn') ? overrides.articleNumberColumn! : 'videlicet',
        ebomName: overrides && overrides.hasOwnProperty('ebomName') ? overrides.ebomName! : 'complectus',
        encoding: overrides && overrides.hasOwnProperty('encoding') ? overrides.encoding! : CsvEncoding.Iso_8859_1,
        nameColumn: overrides && overrides.hasOwnProperty('nameColumn') ? overrides.nameColumn! : 'contra',
        parentArticleNumberColumn: overrides && overrides.hasOwnProperty('parentArticleNumberColumn') ? overrides.parentArticleNumberColumn! : 'coadunatio',
        positionColumn: overrides && overrides.hasOwnProperty('positionColumn') ? overrides.positionColumn! : 'denuo',
        quantityColumn: overrides && overrides.hasOwnProperty('quantityColumn') ? overrides.quantityColumn! : 'eum',
        revisionColumn: overrides && overrides.hasOwnProperty('revisionColumn') ? overrides.revisionColumn! : 'nisi',
        unitColumn: overrides && overrides.hasOwnProperty('unitColumn') ? overrides.unitColumn! : 'tenus',
    };
};

export const mockCsvExtension = (overrides?: Partial<CsvExtension>): CsvExtension => {
    return {
        columnNames: overrides && overrides.hasOwnProperty('columnNames') ? overrides.columnNames! : ['vulticulus'],
    };
};

export const mockCurrentUserAndPermissions = (overrides?: Partial<CurrentUserAndPermissions>): CurrentUserAndPermissions => {
    return {
        orgPermissions: overrides && overrides.hasOwnProperty('orgPermissions') ? overrides.orgPermissions! : [PermissionOrganization.OrgAdmin],
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : mockOrganization(),
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : mockUser(),
        userPermissions: overrides && overrides.hasOwnProperty('userPermissions') ? overrides.userPermissions! : [PermissionUser.UserGlobalAdmin],
    };
};

export const mockDagNode = (overrides?: Partial<DagNode>): DagNode => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '18eeadc7-1a76-40ec-9d81-771c45999ba5',
        parentIds: overrides && overrides.hasOwnProperty('parentIds') ? overrides.parentIds! : ['e4eea69a-45df-4392-8e84-a64da9d791c4'],
    };
};

export const mockDeleteCheckCommand = (overrides?: Partial<DeleteCheckCommand>): DeleteCheckCommand => {
    return {
        checkConfigurationId: overrides && overrides.hasOwnProperty('checkConfigurationId') ? overrides.checkConfigurationId! : '1e52262f-2600-47a9-8dc7-d92c241207eb',
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'attero',
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'desparatus',
    };
};

export const mockDeleteOrganizationPermissions = (overrides?: Partial<DeleteOrganizationPermissions>): DeleteOrganizationPermissions => {
    return {
        orgId: overrides && overrides.hasOwnProperty('orgId') ? overrides.orgId! : '707fe8ad-e3f1-46f1-85a0-316009b77d4b',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : '957f5c86-8f53-4e12-b89f-c1ddf4d375e9',
    };
};

export const mockDraftBopByDuplicating = (overrides?: Partial<DraftBopByDuplicating>): DraftBopByDuplicating => {
    return {
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : '8b46e0eb-c553-4b09-860b-25d86e519c84',
        productConfigId: overrides && overrides.hasOwnProperty('productConfigId') ? overrides.productConfigId! : '2a251773-250f-4273-a646-bab12442bfc9',
        siteId: overrides && overrides.hasOwnProperty('siteId') ? overrides.siteId! : '82182c96-b470-4adf-82a5-6d19ea6ff93e',
    };
};

export const mockDuplicateModule = (overrides?: Partial<DuplicateModule>): DuplicateModule => {
    return {
        fromBOPId: overrides && overrides.hasOwnProperty('fromBOPId') ? overrides.fromBOPId! : 'e99a4387-8b32-4ed4-a21d-228566df6411',
        fromModuleId: overrides && overrides.hasOwnProperty('fromModuleId') ? overrides.fromModuleId! : '461ebf22-a187-4537-bdd7-534631a08486',
        toBOPId: overrides && overrides.hasOwnProperty('toBOPId') ? overrides.toBOPId! : '88c02b17-f499-46cd-bd86-670541e133ed',
    };
};

export const mockDuplicateStep = (overrides?: Partial<DuplicateStep>): DuplicateStep => {
    return {
        fromBOPId: overrides && overrides.hasOwnProperty('fromBOPId') ? overrides.fromBOPId! : '17b4893d-4be8-4cb2-983d-26de7696ed50',
        fromModuleId: overrides && overrides.hasOwnProperty('fromModuleId') ? overrides.fromModuleId! : '87c4cb14-94f2-4871-93f7-760ca0797ea2',
        fromStepId: overrides && overrides.hasOwnProperty('fromStepId') ? overrides.fromStepId! : '0d3e5801-fc68-4b7b-9f26-f7a2d8fc9b51',
        toBOPId: overrides && overrides.hasOwnProperty('toBOPId') ? overrides.toBOPId! : 'f1a92f05-ce39-49d6-a468-5a1ff7507401',
        toModuleId: overrides && overrides.hasOwnProperty('toModuleId') ? overrides.toModuleId! : 'b93bcbea-2332-49ad-bd7f-75f39158d646',
    };
};

export const mockEbom = (overrides?: Partial<Ebom>): Ebom => {
    return {
        bopUpload: overrides && overrides.hasOwnProperty('bopUpload') ? overrides.bopUpload! : mockBopUpload(),
        ebomParts: overrides && overrides.hasOwnProperty('ebomParts') ? overrides.ebomParts! : [mockEbomPart()],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6282c396-c5e0-4344-bcaa-8b7021e6533d',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'claudeo',
        sourceId: overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'canonicus',
        sourceType: overrides && overrides.hasOwnProperty('sourceType') ? overrides.sourceType! : EbomSourceType.Csv,
    };
};

export const mockEbomPart = (overrides?: Partial<EbomPart>): EbomPart => {
    return {
        article: overrides && overrides.hasOwnProperty('article') ? overrides.article! : mockArticle(),
        articleNumber: overrides && overrides.hasOwnProperty('articleNumber') ? overrides.articleNumber! : 'aequitas',
        articlePath: overrides && overrides.hasOwnProperty('articlePath') ? overrides.articlePath! : mockArticlePath(),
        ebomId: overrides && overrides.hasOwnProperty('ebomId') ? overrides.ebomId! : '04060cb7-7e44-46ed-b3b9-c69568c7aa75',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e9856b11-e16e-427b-a2de-6aa5949aa875',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 1035,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'amet',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : '3d7ee94a-f337-4c0b-b652-517e7195e7e5',
        position: overrides && overrides.hasOwnProperty('position') ? overrides.position! : 'demergo',
        revision: overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'patria',
        snoozeStatus: overrides && overrides.hasOwnProperty('snoozeStatus') ? overrides.snoozeStatus! : EbomPartSnoozeStatus.None,
        stepAllocationSuggestions: overrides && overrides.hasOwnProperty('stepAllocationSuggestions') ? overrides.stepAllocationSuggestions! : [mockEbomPartAllocationSuggestion()],
        stepAllocations: overrides && overrides.hasOwnProperty('stepAllocations') ? overrides.stepAllocations! : [mockEbomPartAllocation()],
        unit: overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : ArticleUnit.Gram,
    };
};

export const mockEbomPartAllocation = (overrides?: Partial<EbomPartAllocation>): EbomPartAllocation => {
    return {
        article: overrides && overrides.hasOwnProperty('article') ? overrides.article! : mockArticle(),
        ebomPart: overrides && overrides.hasOwnProperty('ebomPart') ? overrides.ebomPart! : mockEbomPart(),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1db9d575-428a-4105-a60f-5c992b3e5e3c',
        instanceIndexes: overrides && overrides.hasOwnProperty('instanceIndexes') ? overrides.instanceIndexes! : [9434],
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 1705,
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockEbomPartAllocationSuggestion = (overrides?: Partial<EbomPartAllocationSuggestion>): EbomPartAllocationSuggestion => {
    return {
        decision: overrides && overrides.hasOwnProperty('decision') ? overrides.decision! : EbomPartAllocationSuggestionDecision.Accepted,
        ebomPart: overrides && overrides.hasOwnProperty('ebomPart') ? overrides.ebomPart! : mockEbomPart(),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f844bfe0-ef4b-4d12-9409-413acaf9b5fd',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 8866,
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : EbomPartAllocationSuggestionSource.HistoricAllocation,
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockEbomPartSearchQuery = (overrides?: Partial<EbomPartSearchQuery>): EbomPartSearchQuery => {
    return {
        contextGraphNodeStepId: overrides && overrides.hasOwnProperty('contextGraphNodeStepId') ? overrides.contextGraphNodeStepId! : 'cc0411b5-df77-4b6f-b110-979b5cf7664c',
        contextStepId: overrides && overrides.hasOwnProperty('contextStepId') ? overrides.contextStepId! : 'dbeec833-999e-4ef6-a36d-1ab549cddf3f',
        ebomId: overrides && overrides.hasOwnProperty('ebomId') ? overrides.ebomId! : '1d3d5d2f-31bb-412d-b92f-70c061328d3f',
        searchString: overrides && overrides.hasOwnProperty('searchString') ? overrides.searchString! : 'teres',
    };
};

export const mockFileUploadCheck = (overrides?: Partial<FileUploadCheck>): FileUploadCheck => {
    return {
        configuration: overrides && overrides.hasOwnProperty('configuration') ? overrides.configuration! : mockCheckConfiguration(),
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'corrigo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0a9d6241-50ab-41fa-ab96-31166fc58835',
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'credo',
        released: overrides && overrides.hasOwnProperty('released') ? overrides.released! : false,
        reportingUser: overrides && overrides.hasOwnProperty('reportingUser') ? overrides.reportingUser! : mockUser(),
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'tamisium',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'compono',
        upload: overrides && overrides.hasOwnProperty('upload') ? overrides.upload! : mockUpload(),
    };
};

export const mockGenericExtension = (overrides?: Partial<GenericExtension>): GenericExtension => {
    return {
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : '0f2aa28d-9a30-4a8f-9a09-ec0c2edc060e',
    };
};

export const mockIArticle = (overrides?: Partial<IArticle>): IArticle => {
    return {
        articleNumber: overrides && overrides.hasOwnProperty('articleNumber') ? overrides.articleNumber! : 'asperiores',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7a965370-4ba0-4976-996a-2cdf2bb9099b',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quas',
        revision: overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'absorbeo',
        unit: overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : ArticleUnit.Gram,
    };
};

export const mockIArticleAllocation = (overrides?: Partial<IArticleAllocation>): IArticleAllocation => {
    return {
        article: overrides && overrides.hasOwnProperty('article') ? overrides.article! : mockArticle(),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a924e7f4-c635-4d92-86a7-961dc0bf3920',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 5203,
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockIStepUpload = (overrides?: Partial<IStepUpload>): IStepUpload => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a1d66ea0-c861-49e1-8737-940792e1cf90',
        upload: overrides && overrides.hasOwnProperty('upload') ? overrides.upload! : mockUpload(),
    };
};

export const mockIcon = (overrides?: Partial<Icon>): Icon => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7ff9d8fc-95ae-4f2d-8ba6-ba8ef9758153',
        imageUpload: overrides && overrides.hasOwnProperty('imageUpload') ? overrides.imageUpload! : mockUpload(),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'crapula',
    };
};

export const mockIconUploadUsageLocation = (overrides?: Partial<IconUploadUsageLocation>): IconUploadUsageLocation => {
    return {
        icon: overrides && overrides.hasOwnProperty('icon') ? overrides.icon! : mockIcon(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockImageExtension = (overrides?: Partial<ImageExtension>): ImageExtension => {
    return {
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'ultio',
    };
};

export const mockImageOptions = (overrides?: Partial<ImageOptions>): ImageOptions => {
    return {
        height: overrides && overrides.hasOwnProperty('height') ? overrides.height! : 3455,
        width: overrides && overrides.hasOwnProperty('width') ? overrides.width! : 5670,
    };
};

export const mockImageStepUpload = (overrides?: Partial<ImageStepUpload>): ImageStepUpload => {
    return {
        caption: overrides && overrides.hasOwnProperty('caption') ? overrides.caption! : 'nostrum',
        editLayer: overrides && overrides.hasOwnProperty('editLayer') ? overrides.editLayer! : 'suus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a6c0e5d0-3da6-4f03-a941-00965627b6ff',
        originalUpload: overrides && overrides.hasOwnProperty('originalUpload') ? overrides.originalUpload! : mockUpload(),
        upload: overrides && overrides.hasOwnProperty('upload') ? overrides.upload! : mockUpload(),
    };
};

export const mockInviteUserToOrganization = (overrides?: Partial<InviteUserToOrganization>): InviteUserToOrganization => {
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'cado',
        firstname: overrides && overrides.hasOwnProperty('firstname') ? overrides.firstname! : 'adicio',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e50321a3-9700-4717-bb2a-ad60a4461d66',
        lastname: overrides && overrides.hasOwnProperty('lastname') ? overrides.lastname! : 'clamo',
        needsPassword: overrides && overrides.hasOwnProperty('needsPassword') ? overrides.needsPassword! : true,
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : [PermissionOrganization.OrgAdmin],
    };
};

export const mockIssue = (overrides?: Partial<Issue>): Issue => {
    return {
        assignedToUserIds: overrides && overrides.hasOwnProperty('assignedToUserIds') ? overrides.assignedToUserIds! : ['a5cca66f-01e8-40e7-896a-44580b320e7d'],
        assignedToUsers: overrides && overrides.hasOwnProperty('assignedToUsers') ? overrides.assignedToUsers! : [mockUser()],
        comments: overrides && overrides.hasOwnProperty('comments') ? overrides.comments! : [mockIssueComment()],
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'tui',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : mockUser(),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'velociter',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7cc9664c-4994-41da-bf8b-46e68a7dc65e',
        labels: overrides && overrides.hasOwnProperty('labels') ? overrides.labels! : [mockIssueLabel()],
        links: overrides && overrides.hasOwnProperty('links') ? overrides.links! : [mockArticleIssueLink()],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vulgivagus',
        resolvedAt: overrides && overrides.hasOwnProperty('resolvedAt') ? overrides.resolvedAt! : 'quasi',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'necessitatibus',
        uploadIds: overrides && overrides.hasOwnProperty('uploadIds') ? overrides.uploadIds! : ['599e5735-f06c-4d1e-ac67-3ce51ab8f1e2'],
        uploads: overrides && overrides.hasOwnProperty('uploads') ? overrides.uploads! : [mockUpload()],
    };
};

export const mockIssueComment = (overrides?: Partial<IssueComment>): IssueComment => {
    return {
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'strenuus',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : mockUser(),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'bardus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3ff3f426-a637-45bc-ad9e-f16ff1ffb0e7',
        resolvedAt: overrides && overrides.hasOwnProperty('resolvedAt') ? overrides.resolvedAt! : 'corrumpo',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'cariosus',
        uploadIds: overrides && overrides.hasOwnProperty('uploadIds') ? overrides.uploadIds! : ['632e9b5b-4594-4a44-9c64-ccc5e578fb5b'],
        uploads: overrides && overrides.hasOwnProperty('uploads') ? overrides.uploads! : [mockUpload()],
    };
};

export const mockIssueCommentUploadUsageLocation = (overrides?: Partial<IssueCommentUploadUsageLocation>): IssueCommentUploadUsageLocation => {
    return {
        comment: overrides && overrides.hasOwnProperty('comment') ? overrides.comment! : mockIssueComment(),
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssue(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockIssueLabel = (overrides?: Partial<IssueLabel>): IssueLabel => {
    return {
        color: overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'tergeo',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'convoco',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ba9ce83a-e394-48ef-94c4-bbbfd7034170',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'corporis',
        orgId: overrides && overrides.hasOwnProperty('orgId') ? overrides.orgId! : '437a3268-2828-40e2-b7e1-3d8227b2310c',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'quasi',
    };
};

export const mockIssueLinkI = (overrides?: Partial<IssueLinkI>): IssueLinkI => {
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tripudio',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dc4c9505-e26c-4774-9f62-f4896c7534dd',
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssue(),
    };
};

export const mockIssueMutationRoot = (overrides?: Partial<IssueMutationRoot>): IssueMutationRoot => {
    return {
        createIssue: overrides && overrides.hasOwnProperty('createIssue') ? overrides.createIssue! : mockIssue(),
        createIssueComment: overrides && overrides.hasOwnProperty('createIssueComment') ? overrides.createIssueComment! : mockIssueComment(),
        createIssueLabel: overrides && overrides.hasOwnProperty('createIssueLabel') ? overrides.createIssueLabel! : mockIssueLabel(),
        deleteIssue: overrides && overrides.hasOwnProperty('deleteIssue') ? overrides.deleteIssue! : 'b3ae120f-9a3f-4590-9798-6eda2f138e54',
        deleteIssueComment: overrides && overrides.hasOwnProperty('deleteIssueComment') ? overrides.deleteIssueComment! : '3e777ec2-e02a-4f12-bf6f-5df057b7e3f1',
        deleteIssueLabel: overrides && overrides.hasOwnProperty('deleteIssueLabel') ? overrides.deleteIssueLabel! : '702a4d39-6c0b-4927-9566-af60fd62f8b6',
        deleteIssueLink: overrides && overrides.hasOwnProperty('deleteIssueLink') ? overrides.deleteIssueLink! : 'e71505ea-50d2-4d70-9c0b-60702040eda4',
        linkIssueToArticle: overrides && overrides.hasOwnProperty('linkIssueToArticle') ? overrides.linkIssueToArticle! : mockArticleIssueLink(),
        linkIssueToBOP: overrides && overrides.hasOwnProperty('linkIssueToBOP') ? overrides.linkIssueToBOP! : mockBopIssueLink(),
        linkIssueToModule: overrides && overrides.hasOwnProperty('linkIssueToModule') ? overrides.linkIssueToModule! : mockModuleIssueLink(),
        linkIssueToSerialNumber: overrides && overrides.hasOwnProperty('linkIssueToSerialNumber') ? overrides.linkIssueToSerialNumber! : mockSerialNumberIssueLink(),
        linkIssueToSerialNumbers: overrides && overrides.hasOwnProperty('linkIssueToSerialNumbers') ? overrides.linkIssueToSerialNumbers! : [mockSerialNumberIssueLink()],
        linkIssueToStep: overrides && overrides.hasOwnProperty('linkIssueToStep') ? overrides.linkIssueToStep! : mockStepIssueLink(),
        setIssueCommentResolved: overrides && overrides.hasOwnProperty('setIssueCommentResolved') ? overrides.setIssueCommentResolved! : mockIssueComment(),
        setIssueLabels: overrides && overrides.hasOwnProperty('setIssueLabels') ? overrides.setIssueLabels! : [mockIssueLabel()],
        updateIssue: overrides && overrides.hasOwnProperty('updateIssue') ? overrides.updateIssue! : mockIssue(),
        updateIssueComment: overrides && overrides.hasOwnProperty('updateIssueComment') ? overrides.updateIssueComment! : mockIssueComment(),
        updateIssueLabel: overrides && overrides.hasOwnProperty('updateIssueLabel') ? overrides.updateIssueLabel! : mockIssueLabel(),
        updateIssueLink: overrides && overrides.hasOwnProperty('updateIssueLink') ? overrides.updateIssueLink! : mockArticleIssueLink(),
    };
};

export const mockIssueRoot = (overrides?: Partial<IssueRoot>): IssueRoot => {
    return {
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssue(),
        issueComment: overrides && overrides.hasOwnProperty('issueComment') ? overrides.issueComment! : mockIssueComment(),
        issueLink: overrides && overrides.hasOwnProperty('issueLink') ? overrides.issueLink! : mockArticleIssueLink(),
        issues: overrides && overrides.hasOwnProperty('issues') ? overrides.issues! : [mockIssue()],
        issuesPerDay: overrides && overrides.hasOwnProperty('issuesPerDay') ? overrides.issuesPerDay! : [mockIssuesPerDay()],
        orgIssueLabels: overrides && overrides.hasOwnProperty('orgIssueLabels') ? overrides.orgIssueLabels! : [mockIssueLabel()],
    };
};

export const mockIssueSearchQuery = (overrides?: Partial<IssueSearchQuery>): IssueSearchQuery => {
    return {
        assignedToUserId: overrides && overrides.hasOwnProperty('assignedToUserId') ? overrides.assignedToUserId! : '5affe330-dce9-4805-b511-d7fbfddaecdc',
        bopIds: overrides && overrides.hasOwnProperty('bopIds') ? overrides.bopIds! : ['430eaccc-f6fe-4e36-8c51-53ac6255a05b'],
        isResolved: overrides && overrides.hasOwnProperty('isResolved') ? overrides.isResolved! : false,
        labelIds: overrides && overrides.hasOwnProperty('labelIds') ? overrides.labelIds! : ['8f387f5d-73da-45e8-887d-4a920cefa178'],
        poNumbers: overrides && overrides.hasOwnProperty('poNumbers') ? overrides.poNumbers! : ['adamo'],
        serialNumbers: overrides && overrides.hasOwnProperty('serialNumbers') ? overrides.serialNumbers! : ['theatrum'],
        sortBy: overrides && overrides.hasOwnProperty('sortBy') ? overrides.sortBy! : IssueSortBy.CreatedAt,
        sortDirection: overrides && overrides.hasOwnProperty('sortDirection') ? overrides.sortDirection! : SortDirection.Asc,
    };
};

export const mockIssueUploadUsageLocation = (overrides?: Partial<IssueUploadUsageLocation>): IssueUploadUsageLocation => {
    return {
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssue(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockIssuesPerDay = (overrides?: Partial<IssuesPerDay>): IssuesPerDay => {
    return {
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : 8577,
        day: overrides && overrides.hasOwnProperty('day') ? overrides.day! : 'capto',
        open: overrides && overrides.hasOwnProperty('open') ? overrides.open! : 5901,
        resolved: overrides && overrides.hasOwnProperty('resolved') ? overrides.resolved! : 2177,
    };
};

export const mockLibraryItemVersion = (overrides?: Partial<LibraryItemVersion>): LibraryItemVersion => {
    return {
        latestReleasedVersion: overrides && overrides.hasOwnProperty('latestReleasedVersion') ? overrides.latestReleasedVersion! : 8569,
        libraryItemId: overrides && overrides.hasOwnProperty('libraryItemId') ? overrides.libraryItemId! : '393749f9-331a-4e75-9879-3508a17e113a',
        releasedAt: overrides && overrides.hasOwnProperty('releasedAt') ? overrides.releasedAt! : 'absque',
        updateAvailable: overrides && overrides.hasOwnProperty('updateAvailable') ? overrides.updateAvailable! : true,
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 8619,
        versionStatus: overrides && overrides.hasOwnProperty('versionStatus') ? overrides.versionStatus! : VersionStatus.Approved,
    };
};

export const mockLinkIssueToArticle = (overrides?: Partial<LinkIssueToArticle>): LinkIssueToArticle => {
    return {
        articleId: overrides && overrides.hasOwnProperty('articleId') ? overrides.articleId! : 'c7922b63-7d2b-44a9-8c83-f25ca96f3972',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'somnus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6069257f-938c-48d3-abf5-a1e682b74a1a',
        issueId: overrides && overrides.hasOwnProperty('issueId') ? overrides.issueId! : 'b82dfc1d-c495-424c-93a4-c8e90c0f9e5a',
    };
};

export const mockLinkIssueToBop = (overrides?: Partial<LinkIssueToBop>): LinkIssueToBop => {
    return {
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : 'b03a5a13-d26c-4a14-bbec-b2c740b37c3f',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'derelinquo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'de239993-07c9-4605-b17f-1ca9f9f4c876',
        issueId: overrides && overrides.hasOwnProperty('issueId') ? overrides.issueId! : 'cf61ad82-ffd8-4840-835a-21b9301bd33d',
    };
};

export const mockLinkIssueToModule = (overrides?: Partial<LinkIssueToModule>): LinkIssueToModule => {
    return {
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : 'ade1ffee-5077-4ca4-92e9-8d8f4c9f317d',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'nostrum',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8b4dae83-4842-4a99-b2fc-eac4c1e4eb60',
        issueId: overrides && overrides.hasOwnProperty('issueId') ? overrides.issueId! : '96b4d714-a9f2-4664-b126-a55d528cbdf5',
        moduleId: overrides && overrides.hasOwnProperty('moduleId') ? overrides.moduleId! : '3bf95159-179e-4048-a658-d622db95d69a',
    };
};

export const mockLinkIssueToSerialNumber = (overrides?: Partial<LinkIssueToSerialNumber>): LinkIssueToSerialNumber => {
    return {
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : '4aa81096-17b9-49ae-b052-0e1070ca91bd',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'deprecator',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '79a9bcec-1761-42f4-b24e-97f966cd8bdd',
        issueId: overrides && overrides.hasOwnProperty('issueId') ? overrides.issueId! : 'c7cf5b41-58db-4297-9d32-f47e7dba3ee0',
        moduleId: overrides && overrides.hasOwnProperty('moduleId') ? overrides.moduleId! : 'ec6adb8d-6355-4fc8-9d67-80b670acac8e',
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'clamo',
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'denuncio',
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'ec207fd5-3ab5-4412-ad3c-fa06060625f2',
    };
};

export const mockLinkIssueToSerialNumbers = (overrides?: Partial<LinkIssueToSerialNumbers>): LinkIssueToSerialNumbers => {
    return {
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : '3940c47f-ca0d-4a97-82d4-50a08605cd23',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'confido',
        issueId: overrides && overrides.hasOwnProperty('issueId') ? overrides.issueId! : '0a5e3e03-8034-4a35-967d-55c213511ca7',
        moduleId: overrides && overrides.hasOwnProperty('moduleId') ? overrides.moduleId! : 'e1295cff-89cb-4516-8ef7-086d4e14399f',
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'dolorum',
        serialNumbers: overrides && overrides.hasOwnProperty('serialNumbers') ? overrides.serialNumbers! : ['caritas'],
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'ad52cda6-b350-4746-a3c7-3b36293d57df',
    };
};

export const mockLinkIssueToStep = (overrides?: Partial<LinkIssueToStep>): LinkIssueToStep => {
    return {
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : '3baa879f-185c-445a-8365-aac1eb0cc406',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'vorago',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '10f38e91-03d3-4170-aece-0d6f696d97d0',
        issueId: overrides && overrides.hasOwnProperty('issueId') ? overrides.issueId! : '44617789-5e05-496a-a5fa-195ce659131b',
        moduleId: overrides && overrides.hasOwnProperty('moduleId') ? overrides.moduleId! : '887ec2c9-4a1e-4705-9573-7cbc8c20e252',
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '77e06157-c847-4a87-8c27-6ea34df99b51',
    };
};

export const mockLoadEbomFromCsvCommand = (overrides?: Partial<LoadEbomFromCsvCommand>): LoadEbomFromCsvCommand => {
    return {
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : '5f7472a7-a48f-4a27-8d15-7eedfb5c65dd',
        config: overrides && overrides.hasOwnProperty('config') ? overrides.config! : mockCsvConfig(),
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : '22a09fd5-5c85-415c-bbb2-9159bb89bc79',
    };
};

export const mockLoadEbomFromStepFileCommand = (overrides?: Partial<LoadEbomFromStepFileCommand>): LoadEbomFromStepFileCommand => {
    return {
        bopId: overrides && overrides.hasOwnProperty('bopId') ? overrides.bopId! : '2c1a4665-0443-46e4-bf65-9b4493a62571',
        ebomName: overrides && overrides.hasOwnProperty('ebomName') ? overrides.ebomName! : 'demoror',
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : 'a0f80668-bd3b-4951-abc7-37c2e1852f19',
    };
};

export const mockLoadEbomResult = (overrides?: Partial<LoadEbomResult>): LoadEbomResult => {
    return {
        ebom: overrides && overrides.hasOwnProperty('ebom') ? overrides.ebom! : mockEbom(),
        error: overrides && overrides.hasOwnProperty('error') ? overrides.error! : 'apto',
    };
};

export const mockManualArticleAllocation = (overrides?: Partial<ManualArticleAllocation>): ManualArticleAllocation => {
    return {
        article: overrides && overrides.hasOwnProperty('article') ? overrides.article! : mockArticle(),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a2a10ee5-078d-4a5d-89be-91be4eea5ce1',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 3971,
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockModelExtension = (overrides?: Partial<ModelExtension>): ModelExtension => {
    return {
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : 'f3e130f6-b1fb-49b8-b1d5-55d30ca93062',
    };
};

export const mockModule = (overrides?: Partial<Module>): Module => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'aurum',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cornu',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '10f7ec30-0ef9-45d5-aa86-e9c7e62887cd',
        inputs: overrides && overrides.hasOwnProperty('inputs') ? overrides.inputs! : [mockStepInput()],
        issueLinks: overrides && overrides.hasOwnProperty('issueLinks') ? overrides.issueLinks! : [mockArticleIssueLink()],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'solitudo',
        nodes: overrides && overrides.hasOwnProperty('nodes') ? overrides.nodes! : [mockStepNode()],
        outputs: overrides && overrides.hasOwnProperty('outputs') ? overrides.outputs! : [mockStepOutput()],
        removedSteps: overrides && overrides.hasOwnProperty('removedSteps') ? overrides.removedSteps! : [mockRemovedStep()],
    };
};

export const mockModuleIssueLink = (overrides?: Partial<ModuleIssueLink>): ModuleIssueLink => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'demergo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '246a885e-efed-447a-be42-f40b8d58aacf',
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssue(),
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
    };
};

export const mockModuleNode = (overrides?: Partial<ModuleNode>): ModuleNode => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aea7ffb3-9935-4e14-b493-7adc945a89b3',
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        parentIds: overrides && overrides.hasOwnProperty('parentIds') ? overrides.parentIds! : ['8b62b61c-a7da-4c1e-9c38-770cd43330df'],
    };
};

export const mockMove = (overrides?: Partial<Move>): Move => {
    return {
        ids: overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['2b126fc5-e7e4-4f0f-b4cb-794d2cef8ba8'],
        otherId: overrides && overrides.hasOwnProperty('otherId') ? overrides.otherId! : 'a57f04eb-5f47-4170-8351-4b5148c25d11',
        placement: overrides && overrides.hasOwnProperty('placement') ? overrides.placement! : Placement.Above,
    };
};

export const mockMutation = (overrides?: Partial<Mutation>): Mutation => {
    return {
        account: overrides && overrides.hasOwnProperty('account') ? overrides.account! : mockAccountMutationRoot(),
        article: overrides && overrides.hasOwnProperty('article') ? overrides.article! : mockArticleMutationRoot(),
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssueMutationRoot(),
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : mockProductMutationRoot(),
        shopFloor: overrides && overrides.hasOwnProperty('shopFloor') ? overrides.shopFloor! : mockShopFloorMutationRoot(),
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : mockSiteMutationRoot(),
        upload: overrides && overrides.hasOwnProperty('upload') ? overrides.upload! : mockUploadMutationRoot(),
    };
};

export const mockNumericCheck = (overrides?: Partial<NumericCheck>): NumericCheck => {
    return {
        configuration: overrides && overrides.hasOwnProperty('configuration') ? overrides.configuration! : mockCheckConfiguration(),
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'acer',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '2469a390-5adc-4522-9058-828aca5fddf8',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 1049,
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'totus',
        released: overrides && overrides.hasOwnProperty('released') ? overrides.released! : true,
        reportingUser: overrides && overrides.hasOwnProperty('reportingUser') ? overrides.reportingUser! : mockUser(),
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'cunctatio',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'talus',
    };
};

export const mockOrgReachablePermission = (overrides?: Partial<OrgReachablePermission>): OrgReachablePermission => {
    return {
        permission: overrides && overrides.hasOwnProperty('permission') ? overrides.permission! : PermissionOrganization.OrgAdmin,
        reachable: overrides && overrides.hasOwnProperty('reachable') ? overrides.reachable! : [PermissionOrganization.OrgAdmin],
    };
};

export const mockOrganization = (overrides?: Partial<Organization>): Organization => {
    return {
        aiFeatures: overrides && overrides.hasOwnProperty('aiFeatures') ? overrides.aiFeatures! : [mockOrganizationAiFeature()],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '5ffe8aa6-493a-4cfe-91be-f7cb371713d3',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'succedo',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'caelum',
    };
};

export const mockOrganizationAiFeature = (overrides?: Partial<OrganizationAiFeature>): OrganizationAiFeature => {
    return {
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        feature: overrides && overrides.hasOwnProperty('feature') ? overrides.feature! : AiFeature.StepProposalsFromDocument,
    };
};

export const mockOrganizationUserPermissions = (overrides?: Partial<OrganizationUserPermissions>): OrganizationUserPermissions => {
    return {
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : mockOrganization(),
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : [PermissionOrganization.OrgAdmin],
    };
};

export const mockPdfExtension = (overrides?: Partial<PdfExtension>): PdfExtension => {
    return {
        analysis: overrides && overrides.hasOwnProperty('analysis') ? overrides.analysis! : mockPdfExtensionAnalysis(),
    };
};

export const mockPdfExtensionAnalysis = (overrides?: Partial<PdfExtensionAnalysis>): PdfExtensionAnalysis => {
    return {
        errors: overrides && overrides.hasOwnProperty('errors') ? overrides.errors! : ['censura'],
        numberOfImages: overrides && overrides.hasOwnProperty('numberOfImages') ? overrides.numberOfImages! : 4840,
        numberOfPages: overrides && overrides.hasOwnProperty('numberOfPages') ? overrides.numberOfPages! : 6177,
    };
};

export const mockProduct = (overrides?: Partial<Product>): Product => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'quisquam',
        archived: overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : false,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'trado',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8983bd3e-5f2a-444b-80e8-1249ed54ed80',
        imageUpload: overrides && overrides.hasOwnProperty('imageUpload') ? overrides.imageUpload! : mockUpload(),
        imageUploadId: overrides && overrides.hasOwnProperty('imageUploadId') ? overrides.imageUploadId! : '5fd62a36-6fda-4b33-9cdb-eda454006484',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'curo',
        productConfigurations: overrides && overrides.hasOwnProperty('productConfigurations') ? overrides.productConfigurations! : [mockProductConfiguration()],
    };
};

export const mockProductConfiguration = (overrides?: Partial<ProductConfiguration>): ProductConfiguration => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'vomer',
        archived: overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : true,
        bops: overrides && overrides.hasOwnProperty('bops') ? overrides.bops! : [mockBop()],
        bopsAtSite: overrides && overrides.hasOwnProperty('bopsAtSite') ? overrides.bopsAtSite! : [mockBop()],
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'architecto',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '2f56a7d8-cf24-46dc-8fd0-5c5ab8862546',
        imageUpload: overrides && overrides.hasOwnProperty('imageUpload') ? overrides.imageUpload! : mockUpload(),
        imageUploadId: overrides && overrides.hasOwnProperty('imageUploadId') ? overrides.imageUploadId! : 'ebb480de-0228-4342-8a34-f54773d29000',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vindico',
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : mockProduct(),
    };
};

export const mockProductConfigurationUploadUsageLocation = (overrides?: Partial<ProductConfigurationUploadUsageLocation>): ProductConfigurationUploadUsageLocation => {
    return {
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : mockProduct(),
        productConfiguration: overrides && overrides.hasOwnProperty('productConfiguration') ? overrides.productConfiguration! : mockProductConfiguration(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockProductMutationRoot = (overrides?: Partial<ProductMutationRoot>): ProductMutationRoot => {
    return {
        addLibraryStepToModule: overrides && overrides.hasOwnProperty('addLibraryStepToModule') ? overrides.addLibraryStepToModule! : mockStep(),
        addNodeToModuleGraph: overrides && overrides.hasOwnProperty('addNodeToModuleGraph') ? overrides.addNodeToModuleGraph! : false,
        archiveProduct: overrides && overrides.hasOwnProperty('archiveProduct') ? overrides.archiveProduct! : mockProduct(),
        archiveProductConfiguration: overrides && overrides.hasOwnProperty('archiveProductConfiguration') ? overrides.archiveProductConfiguration! : mockProductConfiguration(),
        clearImageStepUploadEdit: overrides && overrides.hasOwnProperty('clearImageStepUploadEdit') ? overrides.clearImageStepUploadEdit! : mockImageStepUpload(),
        createBOPUpload: overrides && overrides.hasOwnProperty('createBOPUpload') ? overrides.createBOPUpload! : mockBopUpload(),
        createCheckConfiguration: overrides && overrides.hasOwnProperty('createCheckConfiguration') ? overrides.createCheckConfiguration! : mockCheckConfiguration(),
        createIcon: overrides && overrides.hasOwnProperty('createIcon') ? overrides.createIcon! : mockIcon(),
        createImageStepUpload: overrides && overrides.hasOwnProperty('createImageStepUpload') ? overrides.createImageStepUpload! : mockImageStepUpload(),
        createLibraryStep: overrides && overrides.hasOwnProperty('createLibraryStep') ? overrides.createLibraryStep! : mockStep(),
        createModule: overrides && overrides.hasOwnProperty('createModule') ? overrides.createModule! : mockModule(),
        createProduct: overrides && overrides.hasOwnProperty('createProduct') ? overrides.createProduct! : mockProduct(),
        createProductConfiguration: overrides && overrides.hasOwnProperty('createProductConfiguration') ? overrides.createProductConfiguration! : mockProductConfiguration(),
        createSnapshotStepUpload: overrides && overrides.hasOwnProperty('createSnapshotStepUpload') ? overrides.createSnapshotStepUpload! : mockImageStepUpload(),
        createStep: overrides && overrides.hasOwnProperty('createStep') ? overrides.createStep! : mockStep(),
        createStepInput: overrides && overrides.hasOwnProperty('createStepInput') ? overrides.createStepInput! : mockStepInput(),
        createStepOutput: overrides && overrides.hasOwnProperty('createStepOutput') ? overrides.createStepOutput! : mockStepOutput(),
        createStepProposalsFromDOCX: overrides && overrides.hasOwnProperty('createStepProposalsFromDOCX') ? overrides.createStepProposalsFromDOCX! : mockStepProposalResult(),
        createStepProposalsFromMedia: overrides && overrides.hasOwnProperty('createStepProposalsFromMedia') ? overrides.createStepProposalsFromMedia! : mockStepProposalResult(),
        createStepProposalsFromPDF: overrides && overrides.hasOwnProperty('createStepProposalsFromPDF') ? overrides.createStepProposalsFromPDF! : mockStepProposalResult(),
        createStepType: overrides && overrides.hasOwnProperty('createStepType') ? overrides.createStepType! : mockStepType(),
        createVideoStepUpload: overrides && overrides.hasOwnProperty('createVideoStepUpload') ? overrides.createVideoStepUpload! : mockVideoStepUpload(),
        createVideoStepUploads: overrides && overrides.hasOwnProperty('createVideoStepUploads') ? overrides.createVideoStepUploads! : [mockVideoStepUpload()],
        deleteBOPUpload: overrides && overrides.hasOwnProperty('deleteBOPUpload') ? overrides.deleteBOPUpload! : 'b5c43197-b53b-4f93-8ce7-e6577238cc5b',
        deleteCheckConfiguration: overrides && overrides.hasOwnProperty('deleteCheckConfiguration') ? overrides.deleteCheckConfiguration! : '62fffe1f-e294-43fc-a306-d390cae2b59d',
        deleteIcon: overrides && overrides.hasOwnProperty('deleteIcon') ? overrides.deleteIcon! : '0110c18b-3ab0-4dfe-a8ca-74c104f50c38',
        deleteLatestUnreleasedBOPVersion: overrides && overrides.hasOwnProperty('deleteLatestUnreleasedBOPVersion') ? overrides.deleteLatestUnreleasedBOPVersion! : '2877142f-daeb-4f37-b73c-1f737c1f3fb3',
        deleteLatestUnreleasedLibraryStepVersion: overrides && overrides.hasOwnProperty('deleteLatestUnreleasedLibraryStepVersion') ? overrides.deleteLatestUnreleasedLibraryStepVersion! : 'b693c2d4-a62e-45ab-b28c-1bc207d95ea8',
        deleteModule: overrides && overrides.hasOwnProperty('deleteModule') ? overrides.deleteModule! : '110674d2-86e1-4a7f-b1a5-5804a99264a0',
        deleteProduct: overrides && overrides.hasOwnProperty('deleteProduct') ? overrides.deleteProduct! : '23537c9d-3eb0-4db6-9880-b584e3694394',
        deleteProductConfiguration: overrides && overrides.hasOwnProperty('deleteProductConfiguration') ? overrides.deleteProductConfiguration! : '1f6555c1-81ee-43b7-802a-02a0a46889f5',
        deleteStep: overrides && overrides.hasOwnProperty('deleteStep') ? overrides.deleteStep! : '355b55e0-4d81-4fcb-afb8-c36a01f03c93',
        deleteStepInput: overrides && overrides.hasOwnProperty('deleteStepInput') ? overrides.deleteStepInput! : '480a2676-c717-4807-a649-6aee12731a24',
        deleteStepOutput: overrides && overrides.hasOwnProperty('deleteStepOutput') ? overrides.deleteStepOutput! : 'b6e5a3e0-b422-4bd4-9604-554b1b341026',
        deleteStepType: overrides && overrides.hasOwnProperty('deleteStepType') ? overrides.deleteStepType! : '1bf46008-67c9-47c5-89a0-01310e161bd8',
        deleteStepUpload: overrides && overrides.hasOwnProperty('deleteStepUpload') ? overrides.deleteStepUpload! : 'cd40ac9e-8c33-40c8-abd8-ac9931a31cd7',
        draftBOP: overrides && overrides.hasOwnProperty('draftBOP') ? overrides.draftBOP! : mockBop(),
        draftBOPByDuplicating: overrides && overrides.hasOwnProperty('draftBOPByDuplicating') ? overrides.draftBOPByDuplicating! : mockBop(),
        draftLibraryStep: overrides && overrides.hasOwnProperty('draftLibraryStep') ? overrides.draftLibraryStep! : mockStep(),
        duplicateModule: overrides && overrides.hasOwnProperty('duplicateModule') ? overrides.duplicateModule! : mockModule(),
        duplicateStep: overrides && overrides.hasOwnProperty('duplicateStep') ? overrides.duplicateStep! : mockStep(),
        moveCheckConfiguration: overrides && overrides.hasOwnProperty('moveCheckConfiguration') ? overrides.moveCheckConfiguration! : true,
        moveStepUpload: overrides && overrides.hasOwnProperty('moveStepUpload') ? overrides.moveStepUpload! : false,
        promoteStepToModule: overrides && overrides.hasOwnProperty('promoteStepToModule') ? overrides.promoteStepToModule! : mockModule(),
        releaseLatestBOPVersion: overrides && overrides.hasOwnProperty('releaseLatestBOPVersion') ? overrides.releaseLatestBOPVersion! : mockBop(),
        releaseLatestLibraryStepVersion: overrides && overrides.hasOwnProperty('releaseLatestLibraryStepVersion') ? overrides.releaseLatestLibraryStepVersion! : mockStep(),
        removeNodeFromModuleGraph: overrides && overrides.hasOwnProperty('removeNodeFromModuleGraph') ? overrides.removeNodeFromModuleGraph! : false,
        saveImageStepUploadEdit: overrides && overrides.hasOwnProperty('saveImageStepUploadEdit') ? overrides.saveImageStepUploadEdit! : mockImageStepUpload(),
        saveStepArticleTransforms: overrides && overrides.hasOwnProperty('saveStepArticleTransforms') ? overrides.saveStepArticleTransforms! : [mockStepArticleTransform()],
        saveStepViewport: overrides && overrides.hasOwnProperty('saveStepViewport') ? overrides.saveStepViewport! : mockStepViewport(),
        setBillOfProcessGraph: overrides && overrides.hasOwnProperty('setBillOfProcessGraph') ? overrides.setBillOfProcessGraph! : true,
        setModuleGraph: overrides && overrides.hasOwnProperty('setModuleGraph') ? overrides.setModuleGraph! : false,
        setPlacementTools: overrides && overrides.hasOwnProperty('setPlacementTools') ? overrides.setPlacementTools! : true,
        setStepArticleVisibility: overrides && overrides.hasOwnProperty('setStepArticleVisibility') ? overrides.setStepArticleVisibility! : mockStep(),
        setStepDurations: overrides && overrides.hasOwnProperty('setStepDurations') ? overrides.setStepDurations! : true,
        setStepIcons: overrides && overrides.hasOwnProperty('setStepIcons') ? overrides.setStepIcons! : mockStep(),
        setStepPreferred3dModel: overrides && overrides.hasOwnProperty('setStepPreferred3dModel') ? overrides.setStepPreferred3dModel! : mockStep(),
        unarchiveProduct: overrides && overrides.hasOwnProperty('unarchiveProduct') ? overrides.unarchiveProduct! : mockProduct(),
        unarchiveProductConfiguration: overrides && overrides.hasOwnProperty('unarchiveProductConfiguration') ? overrides.unarchiveProductConfiguration! : mockProductConfiguration(),
        unlinkLibraryStep: overrides && overrides.hasOwnProperty('unlinkLibraryStep') ? overrides.unlinkLibraryStep! : mockStep(),
        updateCheckConfiguration: overrides && overrides.hasOwnProperty('updateCheckConfiguration') ? overrides.updateCheckConfiguration! : mockCheckConfiguration(),
        updateIcon: overrides && overrides.hasOwnProperty('updateIcon') ? overrides.updateIcon! : mockIcon(),
        updateImageStepUpload: overrides && overrides.hasOwnProperty('updateImageStepUpload') ? overrides.updateImageStepUpload! : mockImageStepUpload(),
        updateLibraryStepToLatestVersion: overrides && overrides.hasOwnProperty('updateLibraryStepToLatestVersion') ? overrides.updateLibraryStepToLatestVersion! : mockBop(),
        updateModule: overrides && overrides.hasOwnProperty('updateModule') ? overrides.updateModule! : mockModule(),
        updateProduct: overrides && overrides.hasOwnProperty('updateProduct') ? overrides.updateProduct! : mockProduct(),
        updateProductConfiguration: overrides && overrides.hasOwnProperty('updateProductConfiguration') ? overrides.updateProductConfiguration! : mockProductConfiguration(),
        updateStep: overrides && overrides.hasOwnProperty('updateStep') ? overrides.updateStep! : mockStep(),
        updateStepInput: overrides && overrides.hasOwnProperty('updateStepInput') ? overrides.updateStepInput! : mockStepInput(),
        updateStepOutput: overrides && overrides.hasOwnProperty('updateStepOutput') ? overrides.updateStepOutput! : mockStepOutput(),
        updateStepType: overrides && overrides.hasOwnProperty('updateStepType') ? overrides.updateStepType! : mockStepType(),
        updateVideoStepUpload: overrides && overrides.hasOwnProperty('updateVideoStepUpload') ? overrides.updateVideoStepUpload! : mockVideoStepUpload(),
    };
};

export const mockProductRoot = (overrides?: Partial<ProductRoot>): ProductRoot => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        bopUpload: overrides && overrides.hasOwnProperty('bopUpload') ? overrides.bopUpload! : mockBopUpload(),
        checkConfigurations: overrides && overrides.hasOwnProperty('checkConfigurations') ? overrides.checkConfigurations! : [mockCheckConfiguration()],
        createStepProposalsFromMediaSupportedMimeTypes: overrides && overrides.hasOwnProperty('createStepProposalsFromMediaSupportedMimeTypes') ? overrides.createStepProposalsFromMediaSupportedMimeTypes! : ['curia'],
        icons: overrides && overrides.hasOwnProperty('icons') ? overrides.icons! : [mockIcon()],
        imageStepUpload: overrides && overrides.hasOwnProperty('imageStepUpload') ? overrides.imageStepUpload! : mockImageStepUpload(),
        libraryStepVersions: overrides && overrides.hasOwnProperty('libraryStepVersions') ? overrides.libraryStepVersions! : [mockStep()],
        librarySteps: overrides && overrides.hasOwnProperty('librarySteps') ? overrides.librarySteps! : [mockStep()],
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        modules: overrides && overrides.hasOwnProperty('modules') ? overrides.modules! : [mockModule()],
        placementArticleAllocations: overrides && overrides.hasOwnProperty('placementArticleAllocations') ? overrides.placementArticleAllocations! : [mockEbomPartAllocation()],
        placementStepInputs: overrides && overrides.hasOwnProperty('placementStepInputs') ? overrides.placementStepInputs! : [mockStepInput()],
        placementStepOutputs: overrides && overrides.hasOwnProperty('placementStepOutputs') ? overrides.placementStepOutputs! : [mockStepOutput()],
        placementToolIds: overrides && overrides.hasOwnProperty('placementToolIds') ? overrides.placementToolIds! : ['14d80b6d-dbab-4792-ae77-e8e5acc7fa00'],
        placementTools: overrides && overrides.hasOwnProperty('placementTools') ? overrides.placementTools! : [mockTool()],
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : mockProduct(),
        productConfiguration: overrides && overrides.hasOwnProperty('productConfiguration') ? overrides.productConfiguration! : mockProductConfiguration(),
        products: overrides && overrides.hasOwnProperty('products') ? overrides.products! : [mockProduct()],
        releasedLibrarySteps: overrides && overrides.hasOwnProperty('releasedLibrarySteps') ? overrides.releasedLibrarySteps! : [mockStep()],
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
        stepDiff: overrides && overrides.hasOwnProperty('stepDiff') ? overrides.stepDiff! : mockStepDiff(),
        stepInput: overrides && overrides.hasOwnProperty('stepInput') ? overrides.stepInput! : mockStepInput(),
        stepOutput: overrides && overrides.hasOwnProperty('stepOutput') ? overrides.stepOutput! : mockStepOutput(),
        stepTypes: overrides && overrides.hasOwnProperty('stepTypes') ? overrides.stepTypes! : [mockStepType()],
        steps: overrides && overrides.hasOwnProperty('steps') ? overrides.steps! : [mockStep()],
        videoStepUpload: overrides && overrides.hasOwnProperty('videoStepUpload') ? overrides.videoStepUpload! : mockVideoStepUpload(),
    };
};

export const mockProductUploadUsageLocation = (overrides?: Partial<ProductUploadUsageLocation>): ProductUploadUsageLocation => {
    return {
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : mockProduct(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockProductionBatch = (overrides?: Partial<ProductionBatch>): ProductionBatch => {
    return {
        assignedUser: overrides && overrides.hasOwnProperty('assignedUser') ? overrides.assignedUser! : mockUser(),
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        completed: overrides && overrides.hasOwnProperty('completed') ? overrides.completed! : false,
        completedAt: overrides && overrides.hasOwnProperty('completedAt') ? overrides.completedAt! : 'molestiae',
        currentStep: overrides && overrides.hasOwnProperty('currentStep') ? overrides.currentStep! : mockStep(),
        durationInSeconds: overrides && overrides.hasOwnProperty('durationInSeconds') ? overrides.durationInSeconds! : 3293,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0d4c750a-cb87-43dd-967d-d6bda80e322b',
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'cupiditas',
        serialNumbers: overrides && overrides.hasOwnProperty('serialNumbers') ? overrides.serialNumbers! : ['depromo'],
        startedAt: overrides && overrides.hasOwnProperty('startedAt') ? overrides.startedAt! : 'delicate',
    };
};

export const mockProductionBatchPage = (overrides?: Partial<ProductionBatchPage>): ProductionBatchPage => {
    return {
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [mockProductionBatch()],
        hasNext: overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true,
        hasPrevious: overrides && overrides.hasOwnProperty('hasPrevious') ? overrides.hasPrevious! : true,
        itemsPerPage: overrides && overrides.hasOwnProperty('itemsPerPage') ? overrides.itemsPerPage! : 9061,
        page: overrides && overrides.hasOwnProperty('page') ? overrides.page! : 6359,
        totalItems: overrides && overrides.hasOwnProperty('totalItems') ? overrides.totalItems! : 2346,
        totalPages: overrides && overrides.hasOwnProperty('totalPages') ? overrides.totalPages! : 9919,
    };
};

export const mockProductionBatchQuery = (overrides?: Partial<ProductionBatchQuery>): ProductionBatchQuery => {
    return {
        completed: overrides && overrides.hasOwnProperty('completed') ? overrides.completed! : true,
        itemsPerPage: overrides && overrides.hasOwnProperty('itemsPerPage') ? overrides.itemsPerPage! : 2977,
        page: overrides && overrides.hasOwnProperty('page') ? overrides.page! : 5563,
        poNumberContains: overrides && overrides.hasOwnProperty('poNumberContains') ? overrides.poNumberContains! : 'defleo',
        serialNumberContains: overrides && overrides.hasOwnProperty('serialNumberContains') ? overrides.serialNumberContains! : 'compono',
    };
};

export const mockPromoteStepToModule = (overrides?: Partial<PromoteStepToModule>): PromoteStepToModule => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'dolorum',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'demulceo',
        graphNodeStepId: overrides && overrides.hasOwnProperty('graphNodeStepId') ? overrides.graphNodeStepId! : 'd00ee66e-eb29-46f0-a587-65a4fa19838f',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '568ec1a4-50bc-49c6-8c0b-54d641344d26',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'demulceo',
    };
};

export const mockQuery = (overrides?: Partial<Query>): Query => {
    return {
        account: overrides && overrides.hasOwnProperty('account') ? overrides.account! : mockAccountRoot(),
        article: overrides && overrides.hasOwnProperty('article') ? overrides.article! : mockArticleRoot(),
        exception: overrides && overrides.hasOwnProperty('exception') ? overrides.exception! : false,
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssueRoot(),
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : mockProductRoot(),
        shopFloor: overrides && overrides.hasOwnProperty('shopFloor') ? overrides.shopFloor! : mockShopFloorRoot(),
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : mockSiteRoot(),
        upload: overrides && overrides.hasOwnProperty('upload') ? overrides.upload! : mockUploadRoot(),
    };
};

export const mockRemovedStep = (overrides?: Partial<RemovedStep>): RemovedStep => {
    return {
        afterStepId: overrides && overrides.hasOwnProperty('afterStepId') ? overrides.afterStepId! : '8b27e2e2-8064-4bfb-8ba5-b3e3e100bd1e',
        parentStepId: overrides && overrides.hasOwnProperty('parentStepId') ? overrides.parentStepId! : '5b0ad1a6-6035-45e5-a029-db8a184c3ab3',
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockReplaceEbomPartAllocation = (overrides?: Partial<ReplaceEbomPartAllocation>): ReplaceEbomPartAllocation => {
    return {
        newEbomPartId: overrides && overrides.hasOwnProperty('newEbomPartId') ? overrides.newEbomPartId! : 'f01409ef-26b6-410b-a7ca-db9aacb59390',
        oldEbomPartId: overrides && overrides.hasOwnProperty('oldEbomPartId') ? overrides.oldEbomPartId! : 'c2fe38f3-a0ae-4e71-8fc2-3094543a544e',
    };
};

export const mockReplaceEbomPartAllocationsCommand = (overrides?: Partial<ReplaceEbomPartAllocationsCommand>): ReplaceEbomPartAllocationsCommand => {
    return {
        replacements: overrides && overrides.hasOwnProperty('replacements') ? overrides.replacements! : [mockReplaceEbomPartAllocation()],
    };
};

export const mockSaveImageStepUploadEdit = (overrides?: Partial<SaveImageStepUploadEdit>): SaveImageStepUploadEdit => {
    return {
        editLayer: overrides && overrides.hasOwnProperty('editLayer') ? overrides.editLayer! : 'adstringo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dba91299-6e2d-46c1-862f-cc45b1657eb4',
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : 'e5e68ca5-82a0-4c36-9c4d-ae5e04d61b55',
    };
};

export const mockSaveStepArticleTransforms = (overrides?: Partial<SaveStepArticleTransforms>): SaveStepArticleTransforms => {
    return {
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '3bba67ba-bbea-4190-8662-577dbe268ca9',
        transforms: overrides && overrides.hasOwnProperty('transforms') ? overrides.transforms! : [mockStepArticleTransformInput()],
    };
};

export const mockSaveStepViewport = (overrides?: Partial<SaveStepViewport>): SaveStepViewport => {
    return {
        cameraX: overrides && overrides.hasOwnProperty('cameraX') ? overrides.cameraX! : 0.6,
        cameraY: overrides && overrides.hasOwnProperty('cameraY') ? overrides.cameraY! : 6,
        cameraZ: overrides && overrides.hasOwnProperty('cameraZ') ? overrides.cameraZ! : 2.2,
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '5725e5ef-6534-408c-910d-4a3da83043fd',
        targetX: overrides && overrides.hasOwnProperty('targetX') ? overrides.targetX! : 8.3,
        targetY: overrides && overrides.hasOwnProperty('targetY') ? overrides.targetY! : 0.5,
        targetZ: overrides && overrides.hasOwnProperty('targetZ') ? overrides.targetZ! : 4.6,
    };
};

export const mockSerialNumberIssueLink = (overrides?: Partial<SerialNumberIssueLink>): SerialNumberIssueLink => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'derideo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8eb471d5-9077-487e-8108-fb1670d0246a',
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssue(),
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'tunc',
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'decipio',
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockSetConfirmCheckCommand = (overrides?: Partial<SetConfirmCheckCommand>): SetConfirmCheckCommand => {
    return {
        checkConfigurationId: overrides && overrides.hasOwnProperty('checkConfigurationId') ? overrides.checkConfigurationId! : '6418836f-764b-4b35-a7f6-be5a8cb04bd7',
        confirmed: overrides && overrides.hasOwnProperty('confirmed') ? overrides.confirmed! : true,
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'vitium',
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'canonicus',
    };
};

export const mockSetDagGraph = (overrides?: Partial<SetDagGraph>): SetDagGraph => {
    return {
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : '9da349e2-f7b2-4874-a65c-fbfdf7a36225',
        nodes: overrides && overrides.hasOwnProperty('nodes') ? overrides.nodes! : [mockSetDagGraphNode()],
    };
};

export const mockSetDagGraphNode = (overrides?: Partial<SetDagGraphNode>): SetDagGraphNode => {
    return {
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : '174199fb-55b7-4efb-af3c-a2a6b2ead05f',
        entityType: overrides && overrides.hasOwnProperty('entityType') ? overrides.entityType! : GraphEntityType.BillOfProcess,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ca08b007-3e3a-4a56-a300-8a38a9ac7f28',
        parentIds: overrides && overrides.hasOwnProperty('parentIds') ? overrides.parentIds! : ['903af46d-fd5b-4067-8968-64336faf8070'],
    };
};

export const mockSetFileUploadCheckCommand = (overrides?: Partial<SetFileUploadCheckCommand>): SetFileUploadCheckCommand => {
    return {
        checkConfigurationId: overrides && overrides.hasOwnProperty('checkConfigurationId') ? overrides.checkConfigurationId! : '749cdf15-8f61-42d6-9b8d-e210b5cd4863',
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'doloremque',
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'laudantium',
        uploadId: overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : '72057b04-68fd-4631-8790-ac3f5a658a62',
    };
};

export const mockSetIssueLabels = (overrides?: Partial<SetIssueLabels>): SetIssueLabels => {
    return {
        issueId: overrides && overrides.hasOwnProperty('issueId') ? overrides.issueId! : '3afe6ecd-7838-46ef-b573-1ee2ab5b9622',
        labelIds: overrides && overrides.hasOwnProperty('labelIds') ? overrides.labelIds! : ['4ef14b18-e46f-4221-bfaf-6f1d1a11e456'],
    };
};

export const mockSetIssueResolved = (overrides?: Partial<SetIssueResolved>): SetIssueResolved => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0e05791c-4ef9-4dd1-bc63-6f0e8e1cc842',
        resolved: overrides && overrides.hasOwnProperty('resolved') ? overrides.resolved! : false,
    };
};

export const mockSetNumericCheckCommand = (overrides?: Partial<SetNumericCheckCommand>): SetNumericCheckCommand => {
    return {
        checkConfigurationId: overrides && overrides.hasOwnProperty('checkConfigurationId') ? overrides.checkConfigurationId! : '9164b12f-6953-47c9-90f9-10c9834a7ff2',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 2867,
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'communis',
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'color',
    };
};

export const mockSetOrganizationAiFeature = (overrides?: Partial<SetOrganizationAiFeature>): SetOrganizationAiFeature => {
    return {
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        feature: overrides && overrides.hasOwnProperty('feature') ? overrides.feature! : AiFeature.StepProposalsFromDocument,
    };
};

export const mockSetOrganizationPermissions = (overrides?: Partial<SetOrganizationPermissions>): SetOrganizationPermissions => {
    return {
        orgId: overrides && overrides.hasOwnProperty('orgId') ? overrides.orgId! : '991059d8-ca7b-4b2c-a50e-ded04f24b737',
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : [PermissionOrganization.OrgAdmin],
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'c802a70c-3655-4cba-8c57-4ee4f51c73f1',
    };
};

export const mockSetPlacementTools = (overrides?: Partial<SetPlacementTools>): SetPlacementTools => {
    return {
        graphNodeStepId: overrides && overrides.hasOwnProperty('graphNodeStepId') ? overrides.graphNodeStepId! : '3cc9931b-a6f7-40b2-948f-ff21936d0293',
        toolIds: overrides && overrides.hasOwnProperty('toolIds') ? overrides.toolIds! : ['f07b0826-171d-49fb-ac55-946eeacabb17'],
    };
};

export const mockSetStepArticleVisibility = (overrides?: Partial<SetStepArticleVisibility>): SetStepArticleVisibility => {
    return {
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'e5e9d732-f885-4305-a758-7a98280bf348',
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : StepArticleVisibility.AllPrevious,
    };
};

export const mockSetStepDuration = (overrides?: Partial<SetStepDuration>): SetStepDuration => {
    return {
        durationInSeconds: overrides && overrides.hasOwnProperty('durationInSeconds') ? overrides.durationInSeconds! : 6810,
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '15b0e15a-d0d6-4d8b-a567-635f2cc27b21',
    };
};

export const mockSetStepDurations = (overrides?: Partial<SetStepDurations>): SetStepDurations => {
    return {
        durations: overrides && overrides.hasOwnProperty('durations') ? overrides.durations! : [mockSetStepDuration()],
    };
};

export const mockSetStepIcons = (overrides?: Partial<SetStepIcons>): SetStepIcons => {
    return {
        iconIds: overrides && overrides.hasOwnProperty('iconIds') ? overrides.iconIds! : ['6d8e8b8f-a949-4d9f-bba1-3699b12988ce'],
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '6712d495-ed98-4652-8250-e8d4f3209c08',
    };
};

export const mockSetStepPreferred3dModel = (overrides?: Partial<SetStepPreferred3dModel>): SetStepPreferred3dModel => {
    return {
        bopUploadId: overrides && overrides.hasOwnProperty('bopUploadId') ? overrides.bopUploadId! : '2fcd5589-235b-42aa-a71d-5a690861d146',
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'a57840de-888a-4afa-a5d1-30d4e2340908',
    };
};

export const mockSetStringCheckCommand = (overrides?: Partial<SetStringCheckCommand>): SetStringCheckCommand => {
    return {
        checkConfigurationId: overrides && overrides.hasOwnProperty('checkConfigurationId') ? overrides.checkConfigurationId! : 'c3fb8ba8-1e23-417a-8fca-a3b0f467d6cf',
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'avaritia',
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'statim',
        text: overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'tabesco',
    };
};

export const mockSetTreeGraph = (overrides?: Partial<SetTreeGraph>): SetTreeGraph => {
    return {
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'd3d9bd7c-07a4-40ac-bf41-2096094bbd29',
        nodes: overrides && overrides.hasOwnProperty('nodes') ? overrides.nodes! : [mockSetTreeGraphNode()],
    };
};

export const mockSetTreeGraphNode = (overrides?: Partial<SetTreeGraphNode>): SetTreeGraphNode => {
    return {
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : '80cfc007-e7b3-4fad-8d82-b017d5dfac24',
        entityType: overrides && overrides.hasOwnProperty('entityType') ? overrides.entityType! : GraphEntityType.BillOfProcess,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '22608cf4-8829-4138-8cd5-7696a0eaea6a',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 'e6738d64-d89e-4f51-8118-a1be99b4f8c3',
    };
};

export const mockSetUserPermissions = (overrides?: Partial<SetUserPermissions>): SetUserPermissions => {
    return {
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : [PermissionUser.UserGlobalAdmin],
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'e7d51109-ac5e-4551-8e31-84ef3bebc595',
    };
};

export const mockShopFloorMutationRoot = (overrides?: Partial<ShopFloorMutationRoot>): ShopFloorMutationRoot => {
    return {
        createProductionBatch: overrides && overrides.hasOwnProperty('createProductionBatch') ? overrides.createProductionBatch! : mockProductionBatch(),
        deleteCheck: overrides && overrides.hasOwnProperty('deleteCheck') ? overrides.deleteCheck! : false,
        deleteProductionBatch: overrides && overrides.hasOwnProperty('deleteProductionBatch') ? overrides.deleteProductionBatch! : '42fdfddf-2b7e-4442-94be-7fa3ef64f2aa',
        markModuleViewed: overrides && overrides.hasOwnProperty('markModuleViewed') ? overrides.markModuleViewed! : false,
        setConfirmCheck: overrides && overrides.hasOwnProperty('setConfirmCheck') ? overrides.setConfirmCheck! : mockConfirmCheck(),
        setFileUploadCheck: overrides && overrides.hasOwnProperty('setFileUploadCheck') ? overrides.setFileUploadCheck! : mockFileUploadCheck(),
        setNumericCheck: overrides && overrides.hasOwnProperty('setNumericCheck') ? overrides.setNumericCheck! : mockNumericCheck(),
        setStringCheck: overrides && overrides.hasOwnProperty('setStringCheck') ? overrides.setStringCheck! : mockStringCheck(),
        transferProductionBatch: overrides && overrides.hasOwnProperty('transferProductionBatch') ? overrides.transferProductionBatch! : mockProductionBatch(),
        updateProductionBatch: overrides && overrides.hasOwnProperty('updateProductionBatch') ? overrides.updateProductionBatch! : mockProductionBatch(),
    };
};

export const mockShopFloorRoot = (overrides?: Partial<ShopFloorRoot>): ShopFloorRoot => {
    return {
        check: overrides && overrides.hasOwnProperty('check') ? overrides.check! : mockConfirmCheck(),
        checks: overrides && overrides.hasOwnProperty('checks') ? overrides.checks! : [mockConfirmCheck()],
        productionBatch: overrides && overrides.hasOwnProperty('productionBatch') ? overrides.productionBatch! : mockProductionBatch(),
        productionBatches: overrides && overrides.hasOwnProperty('productionBatches') ? overrides.productionBatches! : mockProductionBatchPage(),
        productionBatchesInProgressForCurrentUser: overrides && overrides.hasOwnProperty('productionBatchesInProgressForCurrentUser') ? overrides.productionBatchesInProgressForCurrentUser! : [mockProductionBatch()],
        productionBatchesInProgressForUser: overrides && overrides.hasOwnProperty('productionBatchesInProgressForUser') ? overrides.productionBatchesInProgressForUser! : [mockProductionBatch()],
    };
};

export const mockSite = (overrides?: Partial<Site>): Site => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'bestia',
        archived: overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : true,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'c7cf1c40-2cf8-44b4-9096-4777e980f449',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vergo',
        tools: overrides && overrides.hasOwnProperty('tools') ? overrides.tools! : [mockTool()],
    };
};

export const mockSiteMutationRoot = (overrides?: Partial<SiteMutationRoot>): SiteMutationRoot => {
    return {
        createSite: overrides && overrides.hasOwnProperty('createSite') ? overrides.createSite! : mockSite(),
        createTool: overrides && overrides.hasOwnProperty('createTool') ? overrides.createTool! : mockTool(),
        deleteSite: overrides && overrides.hasOwnProperty('deleteSite') ? overrides.deleteSite! : '9c3a69d2-9104-4fc0-9390-664efe411adf',
        deleteTool: overrides && overrides.hasOwnProperty('deleteTool') ? overrides.deleteTool! : '7d2db6ba-ea45-4ae6-b790-72f60551d6fd',
        updateSite: overrides && overrides.hasOwnProperty('updateSite') ? overrides.updateSite! : mockSite(),
        updateTool: overrides && overrides.hasOwnProperty('updateTool') ? overrides.updateTool! : mockTool(),
    };
};

export const mockSiteRoot = (overrides?: Partial<SiteRoot>): SiteRoot => {
    return {
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : mockSite(),
        sites: overrides && overrides.hasOwnProperty('sites') ? overrides.sites! : [mockSite()],
        tool: overrides && overrides.hasOwnProperty('tool') ? overrides.tool! : mockTool(),
    };
};

export const mockStep = (overrides?: Partial<Step>): Step => {
    return {
        activeBopUpload: overrides && overrides.hasOwnProperty('activeBopUpload') ? overrides.activeBopUpload! : mockBopUpload(),
        articleAllocations: overrides && overrides.hasOwnProperty('articleAllocations') ? overrides.articleAllocations! : [mockEbomPartAllocation()],
        articleTransforms: overrides && overrides.hasOwnProperty('articleTransforms') ? overrides.articleTransforms! : [mockStepArticleTransform()],
        articleVisibility: overrides && overrides.hasOwnProperty('articleVisibility') ? overrides.articleVisibility! : StepArticleVisibility.AllPrevious,
        checkConfigurations: overrides && overrides.hasOwnProperty('checkConfigurations') ? overrides.checkConfigurations! : [mockCheckConfiguration()],
        detachedFromLibrary: overrides && overrides.hasOwnProperty('detachedFromLibrary') ? overrides.detachedFromLibrary! : false,
        durationInSeconds: overrides && overrides.hasOwnProperty('durationInSeconds') ? overrides.durationInSeconds! : 9572,
        icons: overrides && overrides.hasOwnProperty('icons') ? overrides.icons! : [mockIcon()],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7f1cd88b-f574-4a90-b156-03a52e5383dd',
        inputs: overrides && overrides.hasOwnProperty('inputs') ? overrides.inputs! : [mockStepInput()],
        instructionText: overrides && overrides.hasOwnProperty('instructionText') ? overrides.instructionText! : 'acidus',
        issueLinks: overrides && overrides.hasOwnProperty('issueLinks') ? overrides.issueLinks! : [mockArticleIssueLink()],
        library: overrides && overrides.hasOwnProperty('library') ? overrides.library! : true,
        libraryItemVersion: overrides && overrides.hasOwnProperty('libraryItemVersion') ? overrides.libraryItemVersion! : mockLibraryItemVersion(),
        libraryStep: overrides && overrides.hasOwnProperty('libraryStep') ? overrides.libraryStep! : mockStep(),
        libraryUsageCount: overrides && overrides.hasOwnProperty('libraryUsageCount') ? overrides.libraryUsageCount! : 90,
        missingIcons: overrides && overrides.hasOwnProperty('missingIcons') ? overrides.missingIcons! : [mockIcon()],
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tabula',
        outputs: overrides && overrides.hasOwnProperty('outputs') ? overrides.outputs! : [mockStepOutput()],
        preferredBopUploadId: overrides && overrides.hasOwnProperty('preferredBopUploadId') ? overrides.preferredBopUploadId! : '266ae786-42c8-4e61-8ca8-ea5a81cfe4e1',
        stepType: overrides && overrides.hasOwnProperty('stepType') ? overrides.stepType! : mockStepType(),
        toolIds: overrides && overrides.hasOwnProperty('toolIds') ? overrides.toolIds! : ['771ba760-c4ad-4dad-a733-4de03d059288'],
        tools: overrides && overrides.hasOwnProperty('tools') ? overrides.tools! : [mockTool()],
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'vigor',
        uploads: overrides && overrides.hasOwnProperty('uploads') ? overrides.uploads! : [mockImageStepUpload()],
        usageCount: overrides && overrides.hasOwnProperty('usageCount') ? overrides.usageCount! : 9864,
        usages: overrides && overrides.hasOwnProperty('usages') ? overrides.usages! : [mockStepUsage()],
        viewport: overrides && overrides.hasOwnProperty('viewport') ? overrides.viewport! : mockStepViewport(),
        warningText: overrides && overrides.hasOwnProperty('warningText') ? overrides.warningText! : 'amaritudo',
    };
};

export const mockStepArticleTransform = (overrides?: Partial<StepArticleTransform>): StepArticleTransform => {
    return {
        articleId: overrides && overrides.hasOwnProperty('articleId') ? overrides.articleId! : '62ec26ea-2630-48de-9e3c-8a6f05eb5597',
        instanceIndex: overrides && overrides.hasOwnProperty('instanceIndex') ? overrides.instanceIndex! : 605,
        positionX: overrides && overrides.hasOwnProperty('positionX') ? overrides.positionX! : 0,
        positionY: overrides && overrides.hasOwnProperty('positionY') ? overrides.positionY! : 7,
        positionZ: overrides && overrides.hasOwnProperty('positionZ') ? overrides.positionZ! : 8.1,
        rotationW: overrides && overrides.hasOwnProperty('rotationW') ? overrides.rotationW! : 9.9,
        rotationX: overrides && overrides.hasOwnProperty('rotationX') ? overrides.rotationX! : 3.5,
        rotationY: overrides && overrides.hasOwnProperty('rotationY') ? overrides.rotationY! : 6.8,
        rotationZ: overrides && overrides.hasOwnProperty('rotationZ') ? overrides.rotationZ! : 7.4,
    };
};

export const mockStepArticleTransformInput = (overrides?: Partial<StepArticleTransformInput>): StepArticleTransformInput => {
    return {
        articleId: overrides && overrides.hasOwnProperty('articleId') ? overrides.articleId! : 'f24af77a-731e-4a9e-a2ec-f12b21597477',
        instanceIndex: overrides && overrides.hasOwnProperty('instanceIndex') ? overrides.instanceIndex! : 9023,
        positionX: overrides && overrides.hasOwnProperty('positionX') ? overrides.positionX! : 0.8,
        positionY: overrides && overrides.hasOwnProperty('positionY') ? overrides.positionY! : 10,
        positionZ: overrides && overrides.hasOwnProperty('positionZ') ? overrides.positionZ! : 0.9,
        rotationW: overrides && overrides.hasOwnProperty('rotationW') ? overrides.rotationW! : 0.3,
        rotationX: overrides && overrides.hasOwnProperty('rotationX') ? overrides.rotationX! : 1.8,
        rotationY: overrides && overrides.hasOwnProperty('rotationY') ? overrides.rotationY! : 3.2,
        rotationZ: overrides && overrides.hasOwnProperty('rotationZ') ? overrides.rotationZ! : 7.8,
    };
};

export const mockStepDiff = (overrides?: Partial<StepDiff>): StepDiff => {
    return {
        changedFields: overrides && overrides.hasOwnProperty('changedFields') ? overrides.changedFields! : [StepChangeField.ArticleAllocations],
        currentStep: overrides && overrides.hasOwnProperty('currentStep') ? overrides.currentStep! : mockStep(),
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : StepChangeKind.Added,
        previousStep: overrides && overrides.hasOwnProperty('previousStep') ? overrides.previousStep! : mockStep(),
    };
};

export const mockStepImageUploadUsageLocation = (overrides?: Partial<StepImageUploadUsageLocation>): StepImageUploadUsageLocation => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockStepInput = (overrides?: Partial<StepInput>): StepInput => {
    return {
        contentArticlePaths: overrides && overrides.hasOwnProperty('contentArticlePaths') ? overrides.contentArticlePaths! : [mockArticlePath()],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '82fd543c-640f-40d7-b8bb-5f3f1cddeba8',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 4298,
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        output: overrides && overrides.hasOwnProperty('output') ? overrides.output! : mockStepOutput(),
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockStepIssueLink = (overrides?: Partial<StepIssueLink>): StepIssueLink => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'crebro',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cb45fdda-5ac7-402e-bc6e-91e48fc6c816',
        issue: overrides && overrides.hasOwnProperty('issue') ? overrides.issue! : mockIssue(),
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockStepNode = (overrides?: Partial<StepNode>): StepNode => {
    return {
        changeKind: overrides && overrides.hasOwnProperty('changeKind') ? overrides.changeKind! : StepChangeKind.Added,
        effectiveArticleAllocations: overrides && overrides.hasOwnProperty('effectiveArticleAllocations') ? overrides.effectiveArticleAllocations! : [mockEbomPartAllocation()],
        effectiveInputs: overrides && overrides.hasOwnProperty('effectiveInputs') ? overrides.effectiveInputs! : [mockStepInput()],
        effectiveOutputs: overrides && overrides.hasOwnProperty('effectiveOutputs') ? overrides.effectiveOutputs! : [mockStepOutput()],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '73e89c82-fc7c-4209-bc74-fa28dbb05051',
        isLibraryReference: overrides && overrides.hasOwnProperty('isLibraryReference') ? overrides.isLibraryReference! : false,
        movedFrom: overrides && overrides.hasOwnProperty('movedFrom') ? overrides.movedFrom! : [5684],
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : '734c9de8-00e5-485c-b3b3-44498b0896b9',
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockStepOutput = (overrides?: Partial<StepOutput>): StepOutput => {
    return {
        article: overrides && overrides.hasOwnProperty('article') ? overrides.article! : mockArticle(),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '374475c2-d00b-4e46-aaa1-919726a00d7f',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 8797,
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockStepProposal = (overrides?: Partial<StepProposal>): StepProposal => {
    return {
        checkProposals: overrides && overrides.hasOwnProperty('checkProposals') ? overrides.checkProposals! : [mockCheckProposal()],
        durationInSeconds: overrides && overrides.hasOwnProperty('durationInSeconds') ? overrides.durationInSeconds! : 1727,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '2ae2bead-8c84-4b3d-b6bc-f023f669835f',
        instructionText: overrides && overrides.hasOwnProperty('instructionText') ? overrides.instructionText! : 'eum',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ascit',
        uploadProposals: overrides && overrides.hasOwnProperty('uploadProposals') ? overrides.uploadProposals! : [mockStepUploadProposal()],
    };
};

export const mockStepProposalResult = (overrides?: Partial<StepProposalResult>): StepProposalResult => {
    return {
        errors: overrides && overrides.hasOwnProperty('errors') ? overrides.errors! : ['caute'],
        proposals: overrides && overrides.hasOwnProperty('proposals') ? overrides.proposals! : [mockStepProposal()],
    };
};

export const mockStepType = (overrides?: Partial<StepType>): StepType => {
    return {
        archived: overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : false,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'd4ca768d-d651-4694-98a9-143f7de23992',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aperte',
        released: overrides && overrides.hasOwnProperty('released') ? overrides.released! : false,
    };
};

export const mockStepUploadProposal = (overrides?: Partial<StepUploadProposal>): StepUploadProposal => {
    return {
        fragmentEndInMillis: overrides && overrides.hasOwnProperty('fragmentEndInMillis') ? overrides.fragmentEndInMillis! : 2292,
        fragmentStartInMillis: overrides && overrides.hasOwnProperty('fragmentStartInMillis') ? overrides.fragmentStartInMillis! : 9828,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e270ac2f-403c-4758-8eea-c5273894878d',
        upload: overrides && overrides.hasOwnProperty('upload') ? overrides.upload! : mockUpload(),
    };
};

export const mockStepUploadUsageLocation = (overrides?: Partial<StepUploadUsageLocation>): StepUploadUsageLocation => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockStepUsage = (overrides?: Partial<StepUsage>): StepUsage => {
    return {
        bop: overrides && overrides.hasOwnProperty('bop') ? overrides.bop! : mockBop(),
        module: overrides && overrides.hasOwnProperty('module') ? overrides.module! : mockModule(),
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : mockStep(),
    };
};

export const mockStepViewport = (overrides?: Partial<StepViewport>): StepViewport => {
    return {
        cameraX: overrides && overrides.hasOwnProperty('cameraX') ? overrides.cameraX! : 9.6,
        cameraY: overrides && overrides.hasOwnProperty('cameraY') ? overrides.cameraY! : 1.2,
        cameraZ: overrides && overrides.hasOwnProperty('cameraZ') ? overrides.cameraZ! : 4.9,
        targetX: overrides && overrides.hasOwnProperty('targetX') ? overrides.targetX! : 0.1,
        targetY: overrides && overrides.hasOwnProperty('targetY') ? overrides.targetY! : 7.8,
        targetZ: overrides && overrides.hasOwnProperty('targetZ') ? overrides.targetZ! : 3.7,
    };
};

export const mockStringCheck = (overrides?: Partial<StringCheck>): StringCheck => {
    return {
        configuration: overrides && overrides.hasOwnProperty('configuration') ? overrides.configuration! : mockCheckConfiguration(),
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'speculum',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9c85242c-f072-48dd-9b0f-becce2569892',
        poNumber: overrides && overrides.hasOwnProperty('poNumber') ? overrides.poNumber! : 'cernuus',
        released: overrides && overrides.hasOwnProperty('released') ? overrides.released! : true,
        reportingUser: overrides && overrides.hasOwnProperty('reportingUser') ? overrides.reportingUser! : mockUser(),
        serialNumber: overrides && overrides.hasOwnProperty('serialNumber') ? overrides.serialNumber! : 'debilito',
        text: overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'theca',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'valeo',
    };
};

export const mockTool = (overrides?: Partial<Tool>): Tool => {
    return {
        archived: overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'summopere',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '93d49ecc-74c8-47c6-9d4d-5239233b9bb0',
        imageUploads: overrides && overrides.hasOwnProperty('imageUploads') ? overrides.imageUploads! : [mockUpload()],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'strues',
        released: overrides && overrides.hasOwnProperty('released') ? overrides.released! : false,
    };
};

export const mockToolImageUploadUsageLocation = (overrides?: Partial<ToolImageUploadUsageLocation>): ToolImageUploadUsageLocation => {
    return {
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : mockSite(),
        tool: overrides && overrides.hasOwnProperty('tool') ? overrides.tool! : mockTool(),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockTransferProductionBatchCommand = (overrides?: Partial<TransferProductionBatchCommand>): TransferProductionBatchCommand => {
    return {
        assignedUserId: overrides && overrides.hasOwnProperty('assignedUserId') ? overrides.assignedUserId! : 'b908ea4c-adc6-400c-91ec-1f1bdae3e174',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e0b1000f-f9d2-4216-a99d-6d2cb29651a4',
    };
};

export const mockTreeGraph = (overrides?: Partial<TreeGraph>): TreeGraph => {
    return {
        nodes: overrides && overrides.hasOwnProperty('nodes') ? overrides.nodes! : [mockTreeNode()],
    };
};

export const mockTreeNode = (overrides?: Partial<TreeNode>): TreeNode => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '53ccf51a-8aed-4c74-8025-eadf6988a214',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : '1d02aba2-05cc-457f-b2e5-288505ad003b',
    };
};

export const mockUnlinkLibraryStep = (overrides?: Partial<UnlinkLibraryStep>): UnlinkLibraryStep => {
    return {
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '1dd1bb1e-32a1-4895-b661-d5d06c56e7cd',
    };
};

export const mockUpdateArticle = (overrides?: Partial<UpdateArticle>): UpdateArticle => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a839257c-d90c-4b28-81a7-6c145c877187',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'capillus',
        unit: overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : ArticleUnit.Gram,
    };
};

export const mockUpdateCheckConfigurationCommand = (overrides?: Partial<UpdateCheckConfigurationCommand>): UpdateCheckConfigurationCommand => {
    return {
        allowedMimeTypes: overrides && overrides.hasOwnProperty('allowedMimeTypes') ? overrides.allowedMimeTypes! : ['conatus'],
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'vulpes',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ff565fa3-3f51-4103-9c33-079653ee1f58',
        isRequired: overrides && overrides.hasOwnProperty('isRequired') ? overrides.isRequired! : false,
        lowerLimit: overrides && overrides.hasOwnProperty('lowerLimit') ? overrides.lowerLimit! : 8849,
        unit: overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : 'virgo',
        upperLimit: overrides && overrides.hasOwnProperty('upperLimit') ? overrides.upperLimit! : 4454,
    };
};

export const mockUpdateIcon = (overrides?: Partial<UpdateIcon>): UpdateIcon => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ae7642d0-5e50-45bf-8063-f5d00b6eebba',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'demonstro',
    };
};

export const mockUpdateImageStepUpload = (overrides?: Partial<UpdateImageStepUpload>): UpdateImageStepUpload => {
    return {
        caption: overrides && overrides.hasOwnProperty('caption') ? overrides.caption! : 'celebrer',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'abbbf00e-7e7f-4a27-b33f-0a1f59868e54',
    };
};

export const mockUpdateIssue = (overrides?: Partial<UpdateIssue>): UpdateIssue => {
    return {
        assignedToUserIds: overrides && overrides.hasOwnProperty('assignedToUserIds') ? overrides.assignedToUserIds! : ['468731a0-384e-4f16-ad00-77173adb867d'],
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tabgo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '11f8b146-dcea-441a-807f-1e720bb52874',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'chirographum',
        resolved: overrides && overrides.hasOwnProperty('resolved') ? overrides.resolved! : true,
        uploadIds: overrides && overrides.hasOwnProperty('uploadIds') ? overrides.uploadIds! : ['ee271dfb-1485-453d-9877-f9ac90a28b27'],
    };
};

export const mockUpdateIssueComment = (overrides?: Partial<UpdateIssueComment>): UpdateIssueComment => {
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'coepi',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '243a9065-f68a-45d8-ae32-6f9f9bacc7d6',
        resolved: overrides && overrides.hasOwnProperty('resolved') ? overrides.resolved! : false,
        uploadIds: overrides && overrides.hasOwnProperty('uploadIds') ? overrides.uploadIds! : ['09fa0bdb-7517-4817-a7bf-b6a6e08e1c7a'],
    };
};

export const mockUpdateIssueLabel = (overrides?: Partial<UpdateIssueLabel>): UpdateIssueLabel => {
    return {
        color: overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'officiis',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6c41fd21-0b98-4f61-82e6-8a1763e47141',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cenaculum',
    };
};

export const mockUpdateIssueLink = (overrides?: Partial<UpdateIssueLink>): UpdateIssueLink => {
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'bestia',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '76063309-954b-4e13-ae75-58de7759148f',
    };
};

export const mockUpdateLibraryStepToLatestVersion = (overrides?: Partial<UpdateLibraryStepToLatestVersion>): UpdateLibraryStepToLatestVersion => {
    return {
        moduleId: overrides && overrides.hasOwnProperty('moduleId') ? overrides.moduleId! : '92ae1dc5-7408-44ae-9560-b05df71a4039',
        stepId: overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : '757dc00a-3eb1-42e7-b337-230160474916',
    };
};

export const mockUpdateModule = (overrides?: Partial<UpdateModule>): UpdateModule => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'volva',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'vilis',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b9f1248f-ebdf-4b19-a36a-fa510421d5eb',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'minus',
    };
};

export const mockUpdateOrganization = (overrides?: Partial<UpdateOrganization>): UpdateOrganization => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '284e2ddb-2b1e-41b8-85a6-db26bf14a599',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'atque',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'caelum',
    };
};

export const mockUpdateProduct = (overrides?: Partial<UpdateProduct>): UpdateProduct => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'suscipit',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cometes',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7792f96d-6d32-4fa5-aebf-8e58aa97c7ba',
        imageUploadId: overrides && overrides.hasOwnProperty('imageUploadId') ? overrides.imageUploadId! : 'b5470bab-6dff-4ebc-8db8-ca458e8a261f',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'conicio',
    };
};

export const mockUpdateProductConfiguration = (overrides?: Partial<UpdateProductConfiguration>): UpdateProductConfiguration => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'studio',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cervus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '34acb3cd-3654-40d6-8df7-4c40066f22d4',
        imageUploadId: overrides && overrides.hasOwnProperty('imageUploadId') ? overrides.imageUploadId! : 'c0c6c0f7-9749-4977-9c59-2c188ae5784a',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'architecto',
    };
};

export const mockUpdateProductionBatchCommand = (overrides?: Partial<UpdateProductionBatchCommand>): UpdateProductionBatchCommand => {
    return {
        assignedUserId: overrides && overrides.hasOwnProperty('assignedUserId') ? overrides.assignedUserId! : '2a032b3b-4ad5-4b39-ade9-f5556001ff6b',
        completed: overrides && overrides.hasOwnProperty('completed') ? overrides.completed! : false,
        currentStepId: overrides && overrides.hasOwnProperty('currentStepId') ? overrides.currentStepId! : '0308275b-ae14-4312-b1b7-c8ccec32a0f6',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '57c4ef2a-ee2f-40a7-a5f9-f9dae8900e40',
    };
};

export const mockUpdateSite = (overrides?: Partial<UpdateSite>): UpdateSite => {
    return {
        abbreviation: overrides && overrides.hasOwnProperty('abbreviation') ? overrides.abbreviation! : 'doloremque',
        archived: overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : false,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8bcfadb9-4cbe-4142-b8ff-79a99057f1e0',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'uredo',
    };
};

export const mockUpdateStep = (overrides?: Partial<UpdateStep>): UpdateStep => {
    return {
        durationInSeconds: overrides && overrides.hasOwnProperty('durationInSeconds') ? overrides.durationInSeconds! : 5875,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f2d3f031-8785-4e16-b473-b4b993e1285e',
        instructionText: overrides && overrides.hasOwnProperty('instructionText') ? overrides.instructionText! : 'ulciscor',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cur',
        stepTypeId: overrides && overrides.hasOwnProperty('stepTypeId') ? overrides.stepTypeId! : 'efc20dcf-2188-4197-91ad-0f69e47f8c4c',
        toolIds: overrides && overrides.hasOwnProperty('toolIds') ? overrides.toolIds! : ['cc36f1fd-798f-429a-871f-e766746d4093'],
        warningText: overrides && overrides.hasOwnProperty('warningText') ? overrides.warningText! : 'allatus',
    };
};

export const mockUpdateStepInput = (overrides?: Partial<UpdateStepInput>): UpdateStepInput => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a64f9f7a-46ee-4a5c-820e-99c7f50afd3e',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 9801,
    };
};

export const mockUpdateStepOutput = (overrides?: Partial<UpdateStepOutput>): UpdateStepOutput => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cb2f3b2f-f1ce-4e09-85fc-ffc50b3efada',
        milliQuantity: overrides && overrides.hasOwnProperty('milliQuantity') ? overrides.milliQuantity! : 8228,
    };
};

export const mockUpdateStepType = (overrides?: Partial<UpdateStepType>): UpdateStepType => {
    return {
        archived: overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : false,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '2fb58c4e-084d-4fcb-929e-8a0d7d038c7f',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'volva',
    };
};

export const mockUpdateTool = (overrides?: Partial<UpdateTool>): UpdateTool => {
    return {
        archived: overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : false,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'utrimque',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e70099c5-5fd9-46f4-b638-a985b94c31bd',
        imageUploadIds: overrides && overrides.hasOwnProperty('imageUploadIds') ? overrides.imageUploadIds! : ['e1ee674c-53ad-4dd6-9fb1-e09f443a0625'],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'avaritia',
    };
};

export const mockUpdateUpload = (overrides?: Partial<UpdateUpload>): UpdateUpload => {
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '2952b213-d47a-4391-a93c-f3b3d6c47f38',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vorago',
    };
};

export const mockUpdateUser = (overrides?: Partial<UpdateUser>): UpdateUser => {
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'venustas',
        firstname: overrides && overrides.hasOwnProperty('firstname') ? overrides.firstname! : 'cinis',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ca0a7cf1-5708-499a-be88-7a2be4a13b29',
        lastname: overrides && overrides.hasOwnProperty('lastname') ? overrides.lastname! : 'caelestis',
    };
};

export const mockUpdateVideoStepUpload = (overrides?: Partial<UpdateVideoStepUpload>): UpdateVideoStepUpload => {
    return {
        caption: overrides && overrides.hasOwnProperty('caption') ? overrides.caption! : 'degero',
        fragmentEndInMillis: overrides && overrides.hasOwnProperty('fragmentEndInMillis') ? overrides.fragmentEndInMillis! : 1020,
        fragmentLoop: overrides && overrides.hasOwnProperty('fragmentLoop') ? overrides.fragmentLoop! : true,
        fragmentStartInMillis: overrides && overrides.hasOwnProperty('fragmentStartInMillis') ? overrides.fragmentStartInMillis! : 7292,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3a4683ea-f257-4d5b-a31f-f372071f5e5d',
    };
};

export const mockUpload = (overrides?: Partial<Upload>): Upload => {
    return {
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : 'laboriosam',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'uredo',
        extension: overrides && overrides.hasOwnProperty('extension') ? overrides.extension! : mockCsvExtension(),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ec077cf7-dc62-4a78-8324-65f032671195',
        imageUrl: overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'voluptatem',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cunae',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'avarus',
        usageLocations: overrides && overrides.hasOwnProperty('usageLocations') ? overrides.usageLocations! : [mockBopUploadUsageLocation()],
    };
};

export const mockUploadMutationRoot = (overrides?: Partial<UploadMutationRoot>): UploadMutationRoot => {
    return {
        createMultipartUpload: overrides && overrides.hasOwnProperty('createMultipartUpload') ? overrides.createMultipartUpload! : 'f3a0e8d7-f2e4-402b-8030-2ce18059d7ec',
        createSnapshotUpload: overrides && overrides.hasOwnProperty('createSnapshotUpload') ? overrides.createSnapshotUpload! : mockUpload(),
        deleteUpload: overrides && overrides.hasOwnProperty('deleteUpload') ? overrides.deleteUpload! : 'c3ce811f-ec32-46ca-be01-2724c28b734b',
        finalizeMultipartUpload: overrides && overrides.hasOwnProperty('finalizeMultipartUpload') ? overrides.finalizeMultipartUpload! : mockUpload(),
        updateUpload: overrides && overrides.hasOwnProperty('updateUpload') ? overrides.updateUpload! : mockUpload(),
    };
};

export const mockUploadQuery = (overrides?: Partial<UploadQuery>): UploadQuery => {
    return {
        inContentTypes: overrides && overrides.hasOwnProperty('inContentTypes') ? overrides.inContentTypes! : ['demergo'],
        nameContains: overrides && overrides.hasOwnProperty('nameContains') ? overrides.nameContains! : 'dedico',
        notInContentTypes: overrides && overrides.hasOwnProperty('notInContentTypes') ? overrides.notInContentTypes! : ['trans'],
        page: overrides && overrides.hasOwnProperty('page') ? overrides.page! : 4914,
        results: overrides && overrides.hasOwnProperty('results') ? overrides.results! : 8007,
        sortBy: overrides && overrides.hasOwnProperty('sortBy') ? overrides.sortBy! : UploadSortField.CreatedAt,
        sortDirection: overrides && overrides.hasOwnProperty('sortDirection') ? overrides.sortDirection! : UploadSortDirection.Asc,
    };
};

export const mockUploadRoot = (overrides?: Partial<UploadRoot>): UploadRoot => {
    return {
        allUploads: overrides && overrides.hasOwnProperty('allUploads') ? overrides.allUploads! : [mockUpload()],
        search: overrides && overrides.hasOwnProperty('search') ? overrides.search! : [mockUpload()],
        upload: overrides && overrides.hasOwnProperty('upload') ? overrides.upload! : mockUpload(),
        uploads: overrides && overrides.hasOwnProperty('uploads') ? overrides.uploads! : [mockUpload()],
    };
};

export const mockUploadUsageLocationI = (overrides?: Partial<UploadUsageLocationI>): UploadUsageLocationI => {
    return {
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : UploadUsageType.BopUpload,
    };
};

export const mockUser = (overrides?: Partial<User>): User => {
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'natus',
        firstname: overrides && overrides.hasOwnProperty('firstname') ? overrides.firstname! : 'ambitus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b5756f00-51a6-422a-81a7-dc13ee6a6375',
        lastname: overrides && overrides.hasOwnProperty('lastname') ? overrides.lastname! : 'collum',
    };
};

export const mockUserSearchCriteria = (overrides?: Partial<UserSearchCriteria>): UserSearchCriteria => {
    return {
        contains: overrides && overrides.hasOwnProperty('contains') ? overrides.contains! : 'audio',
    };
};

export const mockVideoExtension = (overrides?: Partial<VideoExtension>): VideoExtension => {
    return {
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'creator',
    };
};

export const mockVideoStepUpload = (overrides?: Partial<VideoStepUpload>): VideoStepUpload => {
    return {
        caption: overrides && overrides.hasOwnProperty('caption') ? overrides.caption! : 'conitor',
        fragmentEndInMillis: overrides && overrides.hasOwnProperty('fragmentEndInMillis') ? overrides.fragmentEndInMillis! : 7433,
        fragmentLoop: overrides && overrides.hasOwnProperty('fragmentLoop') ? overrides.fragmentLoop! : true,
        fragmentStartInMillis: overrides && overrides.hasOwnProperty('fragmentStartInMillis') ? overrides.fragmentStartInMillis! : 6854,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'd7ca9a26-a03b-49b8-9776-832a82e35ed6',
        trimmedUpload: overrides && overrides.hasOwnProperty('trimmedUpload') ? overrides.trimmedUpload! : mockUpload(),
        upload: overrides && overrides.hasOwnProperty('upload') ? overrides.upload! : mockUpload(),
    };
};
